webpackJsonp([0],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MEGTAKARITAS_TIPUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return JARADEK_TIPUS; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MEGTAKARITAS_TIPUS = 'megtakaritas';
var JARADEK_TIPUS = 'jaradek';

var TipusBase = function () {
	function TipusBase() {
		_classCallCheck(this, TipusBase);
	}

	TipusBase.prototype.isMegtakaritas = function isMegtakaritas() {
		return this.tipus == MEGTAKARITAS_TIPUS;
	};

	TipusBase.prototype.isJaradek = function isJaradek() {
		return this.tipus == JARADEK_TIPUS;
	};

	return TipusBase;
}();

/* harmony default export */ __webpack_exports__["c"] = (TipusBase);

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_component__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kalkulator_form_kalkulator_form_module__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kalkulator_result_kalkulator_result_module__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kalkulator_vhk_kalkulator_vhk_module__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kalkulator_service__ = __webpack_require__(549);





angular.module('kalkulator', [__WEBPACK_IMPORTED_MODULE_1__kalkulator_form_kalkulator_form_module__["a" /* KalkulatorFormModule */], __WEBPACK_IMPORTED_MODULE_2__kalkulator_result_kalkulator_result_module__["a" /* KalkulatorResultModule */], __WEBPACK_IMPORTED_MODULE_3__kalkulator_vhk_kalkulator_vhk_module__["a" /* KalkulatorVhkModule */]]).component('kalkulator', __WEBPACK_IMPORTED_MODULE_0__kalkulator_component__["a" /* KalkulatorComponent */]).service('KalkulatorService', __WEBPACK_IMPORTED_MODULE_4__kalkulator_service__["a" /* KalkulatorService */]);

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! angularjs-slider - v6.4.2 - 
 (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervieu.me>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> - 
 https://github.com/angular-slider/angularjs-slider - 
 2017-12-01 */
/*jslint unparam: true */
/*global angular: false, console: false, define, module */
;(function(root, factory) {
  'use strict'
  /* istanbul ignore next */
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    // to support bundler like browserify
    var angularObj = angular || require('angular')
    if ((!angularObj || !angularObj.module) && typeof angular != 'undefined') {
      angularObj = angular
    }
    module.exports = factory(angularObj)
  } else {
    // Browser globals (root is window)
    factory(root.angular)
  }
})(this, function(angular) {
  'use strict'
  var module = angular
    .module('rzModule', [])
    .factory('RzSliderOptions', function() {
      var defaultOptions = {
        floor: 0,
        ceil: null, //defaults to rz-slider-model
        step: 1,
        precision: 0,
        minRange: null,
        maxRange: null,
        pushRange: false,
        minLimit: null,
        maxLimit: null,
        id: null,
        translate: null,
        getLegend: null,
        stepsArray: null,
        bindIndexForStepsArray: false,
        draggableRange: false,
        draggableRangeOnly: false,
        showSelectionBar: false,
        showSelectionBarEnd: false,
        showSelectionBarFromValue: null,
        showOuterSelectionBars: false,
        hidePointerLabels: false,
        hideLimitLabels: false,
        autoHideLimitLabels: true,
        readOnly: false,
        disabled: false,
        interval: 350,
        showTicks: false,
        showTicksValues: false,
        ticksArray: null,
        ticksTooltip: null,
        ticksValuesTooltip: null,
        vertical: false,
        getSelectionBarColor: null,
        getTickColor: null,
        getPointerColor: null,
        keyboardSupport: true,
        scale: 1,
        enforceStep: true,
        enforceRange: false,
        noSwitching: false,
        onlyBindHandles: false,
        onStart: null,
        onChange: null,
        onEnd: null,
        rightToLeft: false,
        reversedControls: false,
        boundPointerLabels: true,
        mergeRangeLabelsIfSame: false,
        customTemplateScope: null,
        logScale: false,
        customValueToPosition: null,
        customPositionToValue: null,
        selectionBarGradient: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        ariaLabelHigh: null,
        ariaLabelledByHigh: null
      }
      var globalOptions = {}

      var factory = {}
      /**
     * `options({})` allows global configuration of all sliders in the
     * application.
     *
     *   var app = angular.module( 'App', ['rzModule'], function( RzSliderOptions ) {
     *     // show ticks for all sliders
     *     RzSliderOptions.options( { showTicks: true } );
     *   });
     */
      factory.options = function(value) {
        angular.extend(globalOptions, value)
      }

      factory.getOptions = function(options) {
        return angular.extend({}, defaultOptions, globalOptions, options)
      }

      return factory
    })
    .factory('rzThrottle', ['$timeout', function($timeout) {
      /**
     * rzThrottle
     *
     * Taken from underscore project
     *
     * @param {Function} func
     * @param {number} wait
     * @param {ThrottleOptions} options
     * @returns {Function}
     */
      return function(func, wait, options) {
        'use strict'
        /* istanbul ignore next */
        var getTime =
          Date.now ||
          function() {
            return new Date().getTime()
          }
        var context, args, result
        var timeout = null
        var previous = 0
        options = options || {}
        var later = function() {
          previous = getTime()
          timeout = null
          result = func.apply(context, args)
          context = args = null
        }
        return function() {
          var now = getTime()
          var remaining = wait - (now - previous)
          context = this
          args = arguments
          if (remaining <= 0) {
            $timeout.cancel(timeout)
            timeout = null
            previous = now
            result = func.apply(context, args)
            context = args = null
          } else if (!timeout && options.trailing !== false) {
            timeout = $timeout(later, remaining)
          }
          return result
        }
      }
    }])
    .factory('RzSlider', ['$timeout', '$document', '$window', '$compile', 'RzSliderOptions', 'rzThrottle', function(
      $timeout,
      $document,
      $window,
      $compile,
      RzSliderOptions,
      rzThrottle
    ) {
      'use strict'

      /**
     * Slider
     *
     * @param {ngScope} scope            The AngularJS scope
     * @param {Element} sliderElem The slider directive element wrapped in jqLite
     * @constructor
     */
      var Slider = function(scope, sliderElem) {
        /**
       * The slider's scope
       *
       * @type {ngScope}
       */
        this.scope = scope

        /**
       * The slider inner low value (linked to rzSliderModel)
       * @type {number}
       */
        this.lowValue = 0

        /**
       * The slider inner high value (linked to rzSliderHigh)
       * @type {number}
       */
        this.highValue = 0

        /**
       * Slider element wrapped in jqLite
       *
       * @type {jqLite}
       */
        this.sliderElem = sliderElem

        /**
       * Slider type
       *
       * @type {boolean} Set to true for range slider
       */
        this.range =
          this.scope.rzSliderModel !== undefined &&
          this.scope.rzSliderHigh !== undefined

        /**
       * Values recorded when first dragging the bar
       *
       * @type {Object}
       */
        this.dragging = {
          active: false,
          value: 0,
          difference: 0,
          position: 0,
          lowLimit: 0,
          highLimit: 0
        }

        /**
       * property that handle position (defaults to left for horizontal)
       * @type {string}
       */
        this.positionProperty = 'left'

        /**
       * property that handle dimension (defaults to width for horizontal)
       * @type {string}
       */
        this.dimensionProperty = 'width'

        /**
       * Half of the width or height of the slider handles
       *
       * @type {number}
       */
        this.handleHalfDim = 0

        /**
       * Maximum position the slider handle can have
       *
       * @type {number}
       */
        this.maxPos = 0

        /**
       * Precision
       *
       * @type {number}
       */
        this.precision = 0

        /**
       * Step
       *
       * @type {number}
       */
        this.step = 1

        /**
       * The name of the handle we are currently tracking
       *
       * @type {string}
       */
        this.tracking = ''

        /**
       * Minimum value (floor) of the model
       *
       * @type {number}
       */
        this.minValue = 0

        /**
       * Maximum value (ceiling) of the model
       *
       * @type {number}
       */
        this.maxValue = 0

        /**
       * The delta between min and max value
       *
       * @type {number}
       */
        this.valueRange = 0

        /**
       * If showTicks/showTicksValues options are number.
       * In this case, ticks values should be displayed below the slider.
       * @type {boolean}
       */
        this.intermediateTicks = false

        /**
       * Set to true if init method already executed
       *
       * @type {boolean}
       */
        this.initHasRun = false

        /**
       * Used to call onStart on the first keydown event
       *
       * @type {boolean}
       */
        this.firstKeyDown = false

        /**
       * Internal flag to prevent watchers to be called when the sliders value are modified internally.
       * @type {boolean}
       */
        this.internalChange = false

        /**
       * Internal flag to keep track of the visibility of combo label
       * @type {boolean}
       */
        this.cmbLabelShown = false

        /**
       * Internal variable to keep track of the focus element
       */
        this.currentFocusElement = null

        // Slider DOM elements wrapped in jqLite
        this.fullBar = null // The whole slider bar
        this.selBar = null // Highlight between two handles
        this.minH = null // Left slider handle
        this.maxH = null // Right slider handle
        this.flrLab = null // Floor label
        this.ceilLab = null // Ceiling label
        this.minLab = null // Label above the low value
        this.maxLab = null // Label above the high value
        this.cmbLab = null // Combined label
        this.ticks = null // The ticks

        // Initialize slider
        this.init()
      }

      // Add instance methods
      Slider.prototype = {
        /**
       * Initialize slider
       *
       * @returns {undefined}
       */
        init: function() {
          var thrLow,
            thrHigh,
            self = this

          var calcDimFn = function() {
            self.calcViewDimensions()
          }

          this.applyOptions()
          this.syncLowValue()
          if (this.range) this.syncHighValue()
          this.initElemHandles()
          this.manageElementsStyle()
          this.setDisabledState()
          this.calcViewDimensions()
          this.setMinAndMax()
          this.addAccessibility()
          this.updateCeilLab()
          this.updateFloorLab()
          this.initHandles()
          this.manageEventsBindings()

          // Recalculate slider view dimensions
          this.scope.$on('reCalcViewDimensions', calcDimFn)

          // Recalculate stuff if view port dimensions have changed
          angular.element($window).on('resize', calcDimFn)

          this.initHasRun = true

          // Watch for changes to the model
          thrLow = rzThrottle(function() {
            self.onLowHandleChange()
          }, self.options.interval)

          thrHigh = rzThrottle(function() {
            self.onHighHandleChange()
          }, self.options.interval)

          this.scope.$on('rzSliderForceRender', function() {
            self.resetLabelsValue()
            thrLow()
            if (self.range) {
              thrHigh()
            }
            self.resetSlider()
          })

          // Watchers (order is important because in case of simultaneous change,
          // watchers will be called in the same order)
          this.scope.$watchCollection('rzSliderOptions()', function(
            newValue,
            oldValue
          ) {
            if (newValue === oldValue) return
            self.applyOptions() // need to be called before synchronizing the values
            self.syncLowValue()
            if (self.range) self.syncHighValue()
            self.resetSlider()
          })

          this.scope.$watch('rzSliderModel', function(newValue, oldValue) {
            if (self.internalChange) return
            if (newValue === oldValue) return
            thrLow()
          })

          this.scope.$watch('rzSliderHigh', function(newValue, oldValue) {
            if (self.internalChange) return
            if (newValue === oldValue) return
            if (newValue != null) thrHigh()
            if (
              (self.range && newValue == null) ||
              (!self.range && newValue != null)
            ) {
              self.applyOptions()
              self.resetSlider()
            }
          })

          this.scope.$on('$destroy', function() {
            self.unbindEvents()
            angular.element($window).off('resize', calcDimFn)
            self.currentFocusElement = null
          })
        },

        findStepIndex: function(modelValue) {
          var index = 0
          for (var i = 0; i < this.options.stepsArray.length; i++) {
            var step = this.options.stepsArray[i]
            if (step === modelValue) {
              index = i
              break
            } else if (angular.isDate(step)) {
              if (step.getTime() === modelValue.getTime()) {
                index = i
                break
              }
            } else if (angular.isObject(step)) {
              if (
                (angular.isDate(step.value) &&
                  step.value.getTime() === modelValue.getTime()) ||
                step.value === modelValue
              ) {
                index = i
                break
              }
            }
          }
          return index
        },

        syncLowValue: function() {
          if (this.options.stepsArray) {
            if (!this.options.bindIndexForStepsArray)
              this.lowValue = this.findStepIndex(this.scope.rzSliderModel)
            else this.lowValue = this.scope.rzSliderModel
          } else this.lowValue = this.scope.rzSliderModel
        },

        syncHighValue: function() {
          if (this.options.stepsArray) {
            if (!this.options.bindIndexForStepsArray)
              this.highValue = this.findStepIndex(this.scope.rzSliderHigh)
            else this.highValue = this.scope.rzSliderHigh
          } else this.highValue = this.scope.rzSliderHigh
        },

        getStepValue: function(sliderValue) {
          var step = this.options.stepsArray[sliderValue]
          if (angular.isDate(step)) return step
          if (angular.isObject(step)) return step.value
          return step
        },

        applyLowValue: function() {
          if (this.options.stepsArray) {
            if (!this.options.bindIndexForStepsArray)
              this.scope.rzSliderModel = this.getStepValue(this.lowValue)
            else this.scope.rzSliderModel = this.lowValue
          } else this.scope.rzSliderModel = this.lowValue
        },

        applyHighValue: function() {
          if (this.options.stepsArray) {
            if (!this.options.bindIndexForStepsArray)
              this.scope.rzSliderHigh = this.getStepValue(this.highValue)
            else this.scope.rzSliderHigh = this.highValue
          } else this.scope.rzSliderHigh = this.highValue
        },

        /*
       * Reflow the slider when the low handle changes (called with throttle)
       */
        onLowHandleChange: function() {
          this.syncLowValue()
          if (this.range) this.syncHighValue()
          this.setMinAndMax()
          this.updateLowHandle(this.valueToPosition(this.lowValue))
          this.updateSelectionBar()
          this.updateTicksScale()
          this.updateAriaAttributes()
          if (this.range) {
            this.updateCmbLabel()
          }
        },

        /*
       * Reflow the slider when the high handle changes (called with throttle)
       */
        onHighHandleChange: function() {
          this.syncLowValue()
          this.syncHighValue()
          this.setMinAndMax()
          this.updateHighHandle(this.valueToPosition(this.highValue))
          this.updateSelectionBar()
          this.updateTicksScale()
          this.updateCmbLabel()
          this.updateAriaAttributes()
        },

        /**
       * Read the user options and apply them to the slider model
       */
        applyOptions: function() {
          var sliderOptions
          if (this.scope.rzSliderOptions)
            sliderOptions = this.scope.rzSliderOptions()
          else sliderOptions = {}

          this.options = RzSliderOptions.getOptions(sliderOptions)

          if (this.options.step <= 0) this.options.step = 1

          this.range =
            this.scope.rzSliderModel !== undefined &&
            this.scope.rzSliderHigh !== undefined
          this.options.draggableRange =
            this.range && this.options.draggableRange
          this.options.draggableRangeOnly =
            this.range && this.options.draggableRangeOnly
          if (this.options.draggableRangeOnly) {
            this.options.draggableRange = true
          }

          this.options.showTicks =
            this.options.showTicks ||
            this.options.showTicksValues ||
            !!this.options.ticksArray
          this.scope.showTicks = this.options.showTicks //scope is used in the template
          if (
            angular.isNumber(this.options.showTicks) ||
            this.options.ticksArray
          )
            this.intermediateTicks = true

          this.options.showSelectionBar =
            this.options.showSelectionBar ||
            this.options.showSelectionBarEnd ||
            this.options.showSelectionBarFromValue !== null

          if (this.options.stepsArray) {
            this.parseStepsArray()
          } else {
            if (this.options.translate) this.customTrFn = this.options.translate
            else
              this.customTrFn = function(value) {
                return String(value)
              }

            this.getLegend = this.options.getLegend
          }

          if (this.options.vertical) {
            this.positionProperty = 'bottom'
            this.dimensionProperty = 'height'
          }

          if (this.options.customTemplateScope)
            this.scope.custom = this.options.customTemplateScope
        },

        parseStepsArray: function() {
          this.options.floor = 0
          this.options.ceil = this.options.stepsArray.length - 1
          this.options.step = 1

          if (this.options.translate) {
            this.customTrFn = this.options.translate
          } else {
            this.customTrFn = function(modelValue) {
              if (this.options.bindIndexForStepsArray)
                return this.getStepValue(modelValue)
              return modelValue
            }
          }

          this.getLegend = function(index) {
            var step = this.options.stepsArray[index]
            if (angular.isObject(step)) return step.legend
            return null
          }
        },

        /**
       * Resets slider
       *
       * @returns {undefined}
       */
        resetSlider: function() {
          this.manageElementsStyle()
          this.addAccessibility()
          this.setMinAndMax()
          this.updateCeilLab()
          this.updateFloorLab()
          this.unbindEvents()
          this.manageEventsBindings()
          this.setDisabledState()
          this.calcViewDimensions()
          this.refocusPointerIfNeeded()
        },

        refocusPointerIfNeeded: function() {
          if (this.currentFocusElement) {
            this.onPointerFocus(
              this.currentFocusElement.pointer,
              this.currentFocusElement.ref
            )
            this.focusElement(this.currentFocusElement.pointer)
          }
        },

        /**
       * Set the slider children to variables for easy access
       *
       * Run only once during initialization
       *
       * @returns {undefined}
       */
        initElemHandles: function() {
          // Assign all slider elements to object properties for easy access
          angular.forEach(
            this.sliderElem.children(),
            function(elem, index) {
              var jElem = angular.element(elem)

              switch (index) {
                case 0:
                  this.leftOutSelBar = jElem
                  break
                case 1:
                  this.rightOutSelBar = jElem
                  break
                case 2:
                  this.fullBar = jElem
                  break
                case 3:
                  this.selBar = jElem
                  break
                case 4:
                  this.minH = jElem
                  break
                case 5:
                  this.maxH = jElem
                  break
                case 6:
                  this.flrLab = jElem
                  break
                case 7:
                  this.ceilLab = jElem
                  break
                case 8:
                  this.minLab = jElem
                  break
                case 9:
                  this.maxLab = jElem
                  break
                case 10:
                  this.cmbLab = jElem
                  break
                case 11:
                  this.ticks = jElem
                  break
              }
            },
            this
          )

          // Initialize position cache properties
          this.selBar.rzsp = 0
          this.minH.rzsp = 0
          this.maxH.rzsp = 0
          this.flrLab.rzsp = 0
          this.ceilLab.rzsp = 0
          this.minLab.rzsp = 0
          this.maxLab.rzsp = 0
          this.cmbLab.rzsp = 0
        },

        /**
       * Update each elements style based on options
       */
        manageElementsStyle: function() {
          if (!this.range) this.maxH.css('display', 'none')
          else this.maxH.css('display', '')

          this.alwaysHide(
            this.flrLab,
            this.options.showTicksValues || this.options.hideLimitLabels
          )
          this.alwaysHide(
            this.ceilLab,
            this.options.showTicksValues || this.options.hideLimitLabels
          )

          var hideLabelsForTicks =
            this.options.showTicksValues && !this.intermediateTicks
          this.alwaysHide(
            this.minLab,
            hideLabelsForTicks || this.options.hidePointerLabels
          )
          this.alwaysHide(
            this.maxLab,
            hideLabelsForTicks || !this.range || this.options.hidePointerLabels
          )
          this.alwaysHide(
            this.cmbLab,
            hideLabelsForTicks || !this.range || this.options.hidePointerLabels
          )
          this.alwaysHide(
            this.selBar,
            !this.range && !this.options.showSelectionBar
          )
          this.alwaysHide(
            this.leftOutSelBar,
            !this.range || !this.options.showOuterSelectionBars
          )
          this.alwaysHide(
            this.rightOutSelBar,
            !this.range || !this.options.showOuterSelectionBars
          )

          if (this.range && this.options.showOuterSelectionBars) {
            this.fullBar.addClass('rz-transparent')
          }

          if (this.options.vertical) this.sliderElem.addClass('rz-vertical')

          if (this.options.draggableRange) this.selBar.addClass('rz-draggable')
          else this.selBar.removeClass('rz-draggable')

          if (this.intermediateTicks && this.options.showTicksValues)
            this.ticks.addClass('rz-ticks-values-under')
        },

        alwaysHide: function(el, hide) {
          el.rzAlwaysHide = hide
          if (hide) this.hideEl(el)
          else this.showEl(el)
        },

        /**
       * Manage the events bindings based on readOnly and disabled options
       *
       * @returns {undefined}
       */
        manageEventsBindings: function() {
          if (this.options.disabled || this.options.readOnly)
            this.unbindEvents()
          else this.bindEvents()
        },

        /**
       * Set the disabled state based on rzSliderDisabled
       *
       * @returns {undefined}
       */
        setDisabledState: function() {
          if (this.options.disabled) {
            this.sliderElem.attr('disabled', 'disabled')
          } else {
            this.sliderElem.attr('disabled', null)
          }
        },

        /**
       * Reset label values
       *
       * @return {undefined}
       */
        resetLabelsValue: function() {
          this.minLab.rzsv = undefined
          this.maxLab.rzsv = undefined
        },

        /**
       * Initialize slider handles positions and labels
       *
       * Run only once during initialization and every time view port changes size
       *
       * @returns {undefined}
       */
        initHandles: function() {
          this.updateLowHandle(this.valueToPosition(this.lowValue))

          /*
         the order here is important since the selection bar should be
         updated after the high handle but before the combined label
         */
          if (this.range)
            this.updateHighHandle(this.valueToPosition(this.highValue))
          this.updateSelectionBar()
          if (this.range) this.updateCmbLabel()

          this.updateTicksScale()
        },

        /**
       * Translate value to human readable format
       *
       * @param {number|string} value
       * @param {jqLite} label
       * @param {String} which
       * @param {boolean} [useCustomTr]
       * @returns {undefined}
       */
        translateFn: function(value, label, which, useCustomTr) {
          useCustomTr = useCustomTr === undefined ? true : useCustomTr

          var valStr = '',
            getDimension = false,
            noLabelInjection = label.hasClass('no-label-injection')

          if (useCustomTr) {
            if (this.options.stepsArray && !this.options.bindIndexForStepsArray)
              value = this.getStepValue(value)
            valStr = String(this.customTrFn(value, this.options.id, which))
          } else {
            valStr = String(value)
          }

          if (
            label.rzsv === undefined ||
            label.rzsv.length !== valStr.length ||
            (label.rzsv.length > 0 && label.rzsd === 0)
          ) {
            getDimension = true
            label.rzsv = valStr
          }

          if (!noLabelInjection) {
            label.html(valStr)
          }
          this.scope[which + 'Label'] = valStr

          // Update width only when length of the label have changed
          if (getDimension) {
            this.getDimension(label)
          }
        },

        /**
       * Set maximum and minimum values for the slider and ensure the model and high
       * value match these limits
       * @returns {undefined}
       */
        setMinAndMax: function() {
          this.step = +this.options.step
          this.precision = +this.options.precision

          this.minValue = this.options.floor
          if (this.options.logScale && this.minValue === 0)
            throw Error("Can't use floor=0 with logarithmic scale")

          if (this.options.enforceStep) {
            this.lowValue = this.roundStep(this.lowValue)
            if (this.range) this.highValue = this.roundStep(this.highValue)
          }

          if (this.options.ceil != null) this.maxValue = this.options.ceil
          else
            this.maxValue = this.options.ceil = this.range
              ? this.highValue
              : this.lowValue

          if (this.options.enforceRange) {
            this.lowValue = this.sanitizeValue(this.lowValue)
            if (this.range) this.highValue = this.sanitizeValue(this.highValue)
          }

          this.applyLowValue()
          if (this.range) this.applyHighValue()

          this.valueRange = this.maxValue - this.minValue
        },

        /**
       * Adds accessibility attributes
       *
       * Run only once during initialization
       *
       * @returns {undefined}
       */
        addAccessibility: function() {
          this.minH.attr('role', 'slider')
          this.updateAriaAttributes()
          if (
            this.options.keyboardSupport &&
            !(this.options.readOnly || this.options.disabled)
          )
            this.minH.attr('tabindex', '0')
          else this.minH.attr('tabindex', '')
          if (this.options.vertical)
            this.minH.attr('aria-orientation', 'vertical')
          if (this.options.ariaLabel)
            this.minH.attr('aria-label', this.options.ariaLabel)
          else if (this.options.ariaLabelledBy)
            this.minH.attr('aria-labelledby', this.options.ariaLabelledBy)

          if (this.range) {
            this.maxH.attr('role', 'slider')
            if (
              this.options.keyboardSupport &&
              !(this.options.readOnly || this.options.disabled)
            )
              this.maxH.attr('tabindex', '0')
            else this.maxH.attr('tabindex', '')
            if (this.options.vertical)
              this.maxH.attr('aria-orientation', 'vertical')
            if (this.options.ariaLabelHigh)
              this.maxH.attr('aria-label', this.options.ariaLabelHigh)
            else if (this.options.ariaLabelledByHigh)
              this.maxH.attr('aria-labelledby', this.options.ariaLabelledByHigh)
          }
        },

        /**
       * Updates aria attributes according to current values
       */
        updateAriaAttributes: function() {
          this.minH.attr({
            'aria-valuenow': this.scope.rzSliderModel,
            'aria-valuetext': this.customTrFn(
              this.scope.rzSliderModel,
              this.options.id,
              'model'
            ),
            'aria-valuemin': this.minValue,
            'aria-valuemax': this.maxValue
          })
          if (this.range) {
            this.maxH.attr({
              'aria-valuenow': this.scope.rzSliderHigh,
              'aria-valuetext': this.customTrFn(
                this.scope.rzSliderHigh,
                this.options.id,
                'high'
              ),
              'aria-valuemin': this.minValue,
              'aria-valuemax': this.maxValue
            })
          }
        },

        /**
       * Calculate dimensions that are dependent on view port size
       *
       * Run once during initialization and every time view port changes size.
       *
       * @returns {undefined}
       */
        calcViewDimensions: function() {
          var handleWidth = this.getDimension(this.minH)

          this.handleHalfDim = handleWidth / 2
          this.barDimension = this.getDimension(this.fullBar)

          this.maxPos = this.barDimension - handleWidth

          this.getDimension(this.sliderElem)
          this.sliderElem.rzsp = this.sliderElem[0].getBoundingClientRect()[
            this.positionProperty
          ]

          if (this.initHasRun) {
            this.updateFloorLab()
            this.updateCeilLab()
            this.initHandles()
            var self = this
            $timeout(function() {
              self.updateTicksScale()
            })
          }
        },

        /**
       * Update the ticks position
       *
       * @returns {undefined}
       */
        updateTicksScale: function() {
          if (!this.options.showTicks) return

          var ticksArray = this.options.ticksArray || this.getTicksArray(),
            translate = this.options.vertical ? 'translateY' : 'translateX',
            self = this

          if (this.options.rightToLeft) ticksArray.reverse()

          this.scope.ticks = ticksArray.map(function(value) {
            var position = self.valueToPosition(value)

            if (self.options.vertical) position = self.maxPos - position

            var translation = translate + '(' + Math.round(position) + 'px)'
            var tick = {
              selected: self.isTickSelected(value),
              style: {
                '-webkit-transform': translation,
                '-moz-transform': translation,
                '-o-transform': translation,
                '-ms-transform': translation,
                transform: translation
              }
            }
            if (tick.selected && self.options.getSelectionBarColor) {
              tick.style['background-color'] = self.getSelectionBarColor()
            }
            if (!tick.selected && self.options.getTickColor) {
              tick.style['background-color'] = self.getTickColor(value)
            }
            if (self.options.ticksTooltip) {
              tick.tooltip = self.options.ticksTooltip(value)
              tick.tooltipPlacement = self.options.vertical ? 'right' : 'top'
            }
            if (
              self.options.showTicksValues === true ||
              value % self.options.showTicksValues === 0
            ) {
              tick.value = self.getDisplayValue(value, 'tick-value')
              if (self.options.ticksValuesTooltip) {
                tick.valueTooltip = self.options.ticksValuesTooltip(value)
                tick.valueTooltipPlacement = self.options.vertical
                  ? 'right'
                  : 'top'
              }
            }
            if (self.getLegend) {
              var legend = self.getLegend(value, self.options.id)
              if (legend) tick.legend = legend
            }
            return tick
          })
        },

        getTicksArray: function() {
          var step = this.step,
            ticksArray = []
          if (this.intermediateTicks) step = this.options.showTicks
          for (
            var value = this.minValue;
            value <= this.maxValue;
            value += step
          ) {
            ticksArray.push(value)
          }
          return ticksArray
        },

        isTickSelected: function(value) {
          if (!this.range) {
            if (this.options.showSelectionBarFromValue !== null) {
              var center = this.options.showSelectionBarFromValue
              if (
                this.lowValue > center &&
                value >= center &&
                value <= this.lowValue
              )
                return true
              else if (
                this.lowValue < center &&
                value <= center &&
                value >= this.lowValue
              )
                return true
            } else if (this.options.showSelectionBarEnd) {
              if (value >= this.lowValue) return true
            } else if (this.options.showSelectionBar && value <= this.lowValue)
              return true
          }
          if (this.range && value >= this.lowValue && value <= this.highValue)
            return true
          return false
        },

        /**
       * Update position of the floor label
       *
       * @returns {undefined}
       */
        updateFloorLab: function() {
          this.translateFn(this.minValue, this.flrLab, 'floor')
          this.getDimension(this.flrLab)
          var position = this.options.rightToLeft
            ? this.barDimension - this.flrLab.rzsd
            : 0
          this.setPosition(this.flrLab, position)
        },

        /**
       * Update position of the ceiling label
       *
       * @returns {undefined}
       */
        updateCeilLab: function() {
          this.translateFn(this.maxValue, this.ceilLab, 'ceil')
          this.getDimension(this.ceilLab)
          var position = this.options.rightToLeft
            ? 0
            : this.barDimension - this.ceilLab.rzsd
          this.setPosition(this.ceilLab, position)
        },

        /**
       * Update slider handles and label positions
       *
       * @param {string} which
       * @param {number} newPos
       */
        updateHandles: function(which, newPos) {
          if (which === 'lowValue') this.updateLowHandle(newPos)
          else this.updateHighHandle(newPos)

          this.updateSelectionBar()
          this.updateTicksScale()
          if (this.range) this.updateCmbLabel()
        },

        /**
       * Helper function to work out the position for handle labels depending on RTL or not
       *
       * @param {string} labelName maxLab or minLab
       * @param newPos
       *
       * @returns {number}
       */
        getHandleLabelPos: function(labelName, newPos) {
          var labelRzsd = this[labelName].rzsd,
            nearHandlePos = newPos - labelRzsd / 2 + this.handleHalfDim,
            endOfBarPos = this.barDimension - labelRzsd

          if (!this.options.boundPointerLabels) return nearHandlePos

          if (
            (this.options.rightToLeft && labelName === 'minLab') ||
            (!this.options.rightToLeft && labelName === 'maxLab')
          ) {
            return Math.min(nearHandlePos, endOfBarPos)
          } else {
            return Math.min(Math.max(nearHandlePos, 0), endOfBarPos)
          }
        },

        /**
       * Update low slider handle position and label
       *
       * @param {number} newPos
       * @returns {undefined}
       */
        updateLowHandle: function(newPos) {
          this.setPosition(this.minH, newPos)
          this.translateFn(this.lowValue, this.minLab, 'model')
          this.setPosition(
            this.minLab,
            this.getHandleLabelPos('minLab', newPos)
          )

          if (this.options.getPointerColor) {
            var pointercolor = this.getPointerColor('min')
            this.scope.minPointerStyle = {
              backgroundColor: pointercolor
            }
          }

          if (this.options.autoHideLimitLabels) {
            this.shFloorCeil()
          }
        },

        /**
       * Update high slider handle position and label
       *
       * @param {number} newPos
       * @returns {undefined}
       */
        updateHighHandle: function(newPos) {
          this.setPosition(this.maxH, newPos)
          this.translateFn(this.highValue, this.maxLab, 'high')
          this.setPosition(
            this.maxLab,
            this.getHandleLabelPos('maxLab', newPos)
          )

          if (this.options.getPointerColor) {
            var pointercolor = this.getPointerColor('max')
            this.scope.maxPointerStyle = {
              backgroundColor: pointercolor
            }
          }
          if (this.options.autoHideLimitLabels) {
            this.shFloorCeil()
          }
        },

        /**
       * Show/hide floor/ceiling label
       *
       * @returns {undefined}
       */
        shFloorCeil: function() {
          // Show based only on hideLimitLabels if pointer labels are hidden
          if (this.options.hidePointerLabels) {
            return
          }
          var flHidden = false,
            clHidden = false,
            isMinLabAtFloor = this.isLabelBelowFloorLab(this.minLab),
            isMinLabAtCeil = this.isLabelAboveCeilLab(this.minLab),
            isMaxLabAtCeil = this.isLabelAboveCeilLab(this.maxLab),
            isCmbLabAtFloor = this.isLabelBelowFloorLab(this.cmbLab),
            isCmbLabAtCeil = this.isLabelAboveCeilLab(this.cmbLab)

          if (isMinLabAtFloor) {
            flHidden = true
            this.hideEl(this.flrLab)
          } else {
            flHidden = false
            this.showEl(this.flrLab)
          }

          if (isMinLabAtCeil) {
            clHidden = true
            this.hideEl(this.ceilLab)
          } else {
            clHidden = false
            this.showEl(this.ceilLab)
          }

          if (this.range) {
            var hideCeil = this.cmbLabelShown ? isCmbLabAtCeil : isMaxLabAtCeil
            var hideFloor = this.cmbLabelShown
              ? isCmbLabAtFloor
              : isMinLabAtFloor

            if (hideCeil) {
              this.hideEl(this.ceilLab)
            } else if (!clHidden) {
              this.showEl(this.ceilLab)
            }

            // Hide or show floor label
            if (hideFloor) {
              this.hideEl(this.flrLab)
            } else if (!flHidden) {
              this.showEl(this.flrLab)
            }
          }
        },

        isLabelBelowFloorLab: function(label) {
          var isRTL = this.options.rightToLeft,
            pos = label.rzsp,
            dim = label.rzsd,
            floorPos = this.flrLab.rzsp,
            floorDim = this.flrLab.rzsd
          return isRTL
            ? pos + dim >= floorPos - 2
            : pos <= floorPos + floorDim + 2
        },

        isLabelAboveCeilLab: function(label) {
          var isRTL = this.options.rightToLeft,
            pos = label.rzsp,
            dim = label.rzsd,
            ceilPos = this.ceilLab.rzsp,
            ceilDim = this.ceilLab.rzsd
          return isRTL ? pos <= ceilPos + ceilDim + 2 : pos + dim >= ceilPos - 2
        },

        /**
       * Update slider selection bar, combined label and range label
       *
       * @returns {undefined}
       */
        updateSelectionBar: function() {
          var position = 0,
            dimension = 0,
            isSelectionBarFromRight = this.options.rightToLeft
              ? !this.options.showSelectionBarEnd
              : this.options.showSelectionBarEnd,
            positionForRange = this.options.rightToLeft
              ? this.maxH.rzsp + this.handleHalfDim
              : this.minH.rzsp + this.handleHalfDim

          if (this.range) {
            dimension = Math.abs(this.maxH.rzsp - this.minH.rzsp)
            position = positionForRange
          } else {
            if (this.options.showSelectionBarFromValue !== null) {
              var center = this.options.showSelectionBarFromValue,
                centerPosition = this.valueToPosition(center),
                isModelGreaterThanCenter = this.options.rightToLeft
                  ? this.lowValue <= center
                  : this.lowValue > center
              if (isModelGreaterThanCenter) {
                dimension = this.minH.rzsp - centerPosition
                position = centerPosition + this.handleHalfDim
              } else {
                dimension = centerPosition - this.minH.rzsp
                position = this.minH.rzsp + this.handleHalfDim
              }
            } else if (isSelectionBarFromRight) {
              dimension =
                Math.abs(this.maxPos - this.minH.rzsp) + this.handleHalfDim
              position = this.minH.rzsp + this.handleHalfDim
            } else {
              dimension = this.minH.rzsp + this.handleHalfDim
              position = 0
            }
          }
          this.setDimension(this.selBar, dimension)
          this.setPosition(this.selBar, position)
          if (this.range && this.options.showOuterSelectionBars) {
            if (this.options.rightToLeft) {
              this.setDimension(this.rightOutSelBar, position)
              this.setPosition(this.rightOutSelBar, 0)
              this.setDimension(
                this.leftOutSelBar,
                this.getDimension(this.fullBar) - (position + dimension)
              )
              this.setPosition(this.leftOutSelBar, position + dimension)
            } else {
              this.setDimension(this.leftOutSelBar, position)
              this.setPosition(this.leftOutSelBar, 0)
              this.setDimension(
                this.rightOutSelBar,
                this.getDimension(this.fullBar) - (position + dimension)
              )
              this.setPosition(this.rightOutSelBar, position + dimension)
            }
          }
          if (this.options.getSelectionBarColor) {
            var color = this.getSelectionBarColor()
            this.scope.barStyle = {
              backgroundColor: color
            }
          } else if (this.options.selectionBarGradient) {
            var offset =
                this.options.showSelectionBarFromValue !== null
                  ? this.valueToPosition(this.options.showSelectionBarFromValue)
                  : 0,
              reversed = (offset - position > 0) ^ isSelectionBarFromRight,
              direction = this.options.vertical
                ? reversed ? 'bottom' : 'top'
                : reversed ? 'left' : 'right'
            this.scope.barStyle = {
              backgroundImage:
                'linear-gradient(to ' +
                direction +
                ', ' +
                this.options.selectionBarGradient.from +
                ' 0%,' +
                this.options.selectionBarGradient.to +
                ' 100%)'
            }
            if (this.options.vertical) {
              this.scope.barStyle.backgroundPosition =
                'center ' +
                (offset +
                  dimension +
                  position +
                  (reversed ? -this.handleHalfDim : 0)) +
                'px'
              this.scope.barStyle.backgroundSize =
                '100% ' + (this.barDimension - this.handleHalfDim) + 'px'
            } else {
              this.scope.barStyle.backgroundPosition =
                offset -
                position +
                (reversed ? this.handleHalfDim : 0) +
                'px center'
              this.scope.barStyle.backgroundSize =
                this.barDimension - this.handleHalfDim + 'px 100%'
            }
          }
        },

        /**
       * Wrapper around the getSelectionBarColor of the user to pass to
       * correct parameters
       */
        getSelectionBarColor: function() {
          if (this.range)
            return this.options.getSelectionBarColor(
              this.scope.rzSliderModel,
              this.scope.rzSliderHigh
            )
          return this.options.getSelectionBarColor(this.scope.rzSliderModel)
        },

        /**
       * Wrapper around the getPointerColor of the user to pass to
       * correct parameters
       */
        getPointerColor: function(pointerType) {
          if (pointerType === 'max') {
            return this.options.getPointerColor(
              this.scope.rzSliderHigh,
              pointerType
            )
          }
          return this.options.getPointerColor(
            this.scope.rzSliderModel,
            pointerType
          )
        },

        /**
       * Wrapper around the getTickColor of the user to pass to
       * correct parameters
       */
        getTickColor: function(value) {
          return this.options.getTickColor(value)
        },

        /**
       * Update combined label position and value
       *
       * @returns {undefined}
       */
        updateCmbLabel: function() {
          var isLabelOverlap = null
          if (this.options.rightToLeft) {
            isLabelOverlap =
              this.minLab.rzsp - this.minLab.rzsd - 10 <= this.maxLab.rzsp
          } else {
            isLabelOverlap =
              this.minLab.rzsp + this.minLab.rzsd + 10 >= this.maxLab.rzsp
          }

          if (isLabelOverlap) {
            var lowTr = this.getDisplayValue(this.lowValue, 'model'),
              highTr = this.getDisplayValue(this.highValue, 'high'),
              labelVal = ''
            if (this.options.mergeRangeLabelsIfSame && lowTr === highTr) {
              labelVal = lowTr
            } else {
              labelVal = this.options.rightToLeft
                ? highTr + ' - ' + lowTr
                : lowTr + ' - ' + highTr
            }

            this.translateFn(labelVal, this.cmbLab, 'cmb', false)
            var pos = this.options.boundPointerLabels
              ? Math.min(
                  Math.max(
                    this.selBar.rzsp +
                      this.selBar.rzsd / 2 -
                      this.cmbLab.rzsd / 2,
                    0
                  ),
                  this.barDimension - this.cmbLab.rzsd
                )
              : this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2

            this.setPosition(this.cmbLab, pos)
            this.cmbLabelShown = true
            this.hideEl(this.minLab)
            this.hideEl(this.maxLab)
            this.showEl(this.cmbLab)
          } else {
            this.cmbLabelShown = false
            this.updateHighHandle(this.valueToPosition(this.highValue))
            this.updateLowHandle(this.valueToPosition(this.lowValue))
            this.showEl(this.maxLab)
            this.showEl(this.minLab)
            this.hideEl(this.cmbLab)
          }
          if (this.options.autoHideLimitLabels) {
            this.shFloorCeil()
          }
        },

        /**
       * Return the translated value if a translate function is provided else the original value
       * @param value
       * @param which if it's min or max handle
       * @returns {*}
       */
        getDisplayValue: function(value, which) {
          if (this.options.stepsArray && !this.options.bindIndexForStepsArray) {
            value = this.getStepValue(value)
          }
          return this.customTrFn(value, this.options.id, which)
        },

        /**
       * Round value to step and precision based on minValue
       *
       * @param {number} value
       * @param {number} customStep a custom step to override the defined step
       * @returns {number}
       */
        roundStep: function(value, customStep) {
          var step = customStep ? customStep : this.step,
            steppedDifference = parseFloat(
              (value - this.minValue) / step
            ).toPrecision(12)
          steppedDifference = Math.round(+steppedDifference) * step
          var newValue = (this.minValue + steppedDifference).toFixed(
            this.precision
          )
          return +newValue
        },

        /**
       * Hide element
       *
       * @param element
       * @returns {jqLite} The jqLite wrapped DOM element
       */
        hideEl: function(element) {
          return element.css({
            visibility: 'hidden'
          })
        },

        /**
       * Show element
       *
       * @param element The jqLite wrapped DOM element
       * @returns {jqLite} The jqLite
       */
        showEl: function(element) {
          if (!!element.rzAlwaysHide) {
            return element
          }

          return element.css({
            visibility: 'visible'
          })
        },

        /**
       * Set element left/top position depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem The jqLite wrapped DOM element
       * @param {number} pos
       * @returns {number}
       */
        setPosition: function(elem, pos) {
          elem.rzsp = pos
          var css = {}
          css[this.positionProperty] = Math.round(pos) + 'px'
          elem.css(css)
          return pos
        },

        /**
       * Get element width/height depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem The jqLite wrapped DOM element
       * @returns {number}
       */
        getDimension: function(elem) {
          var val = elem[0].getBoundingClientRect()
          if (this.options.vertical)
            elem.rzsd = (val.bottom - val.top) * this.options.scale
          else elem.rzsd = (val.right - val.left) * this.options.scale
          return elem.rzsd
        },

        /**
       * Set element width/height depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem  The jqLite wrapped DOM element
       * @param {number} dim
       * @returns {number}
       */
        setDimension: function(elem, dim) {
          elem.rzsd = dim
          var css = {}
          css[this.dimensionProperty] = Math.round(dim) + 'px'
          elem.css(css)
          return dim
        },

        /**
       * Returns a value that is within slider range
       *
       * @param {number} val
       * @returns {number}
       */
        sanitizeValue: function(val) {
          return Math.min(Math.max(val, this.minValue), this.maxValue)
        },

        /**
       * Translate value to pixel position
       *
       * @param {number} val
       * @returns {number}
       */
        valueToPosition: function(val) {
          var fn = this.linearValueToPosition
          if (this.options.customValueToPosition)
            fn = this.options.customValueToPosition
          else if (this.options.logScale) fn = this.logValueToPosition

          val = this.sanitizeValue(val)
          var percent = fn(val, this.minValue, this.maxValue) || 0
          if (this.options.rightToLeft) percent = 1 - percent
          return percent * this.maxPos
        },

        linearValueToPosition: function(val, minVal, maxVal) {
          var range = maxVal - minVal
          return (val - minVal) / range
        },

        logValueToPosition: function(val, minVal, maxVal) {
          val = Math.log(val)
          minVal = Math.log(minVal)
          maxVal = Math.log(maxVal)
          var range = maxVal - minVal
          return (val - minVal) / range
        },

        /**
       * Translate position to model value
       *
       * @param {number} position
       * @returns {number}
       */
        positionToValue: function(position) {
          var percent = position / this.maxPos
          if (this.options.rightToLeft) percent = 1 - percent
          var fn = this.linearPositionToValue
          if (this.options.customPositionToValue)
            fn = this.options.customPositionToValue
          else if (this.options.logScale) fn = this.logPositionToValue
          return fn(percent, this.minValue, this.maxValue) || 0
        },

        linearPositionToValue: function(percent, minVal, maxVal) {
          return percent * (maxVal - minVal) + minVal
        },

        logPositionToValue: function(percent, minVal, maxVal) {
          minVal = Math.log(minVal)
          maxVal = Math.log(maxVal)
          var value = percent * (maxVal - minVal) + minVal
          return Math.exp(value)
        },

        getEventAttr: function(event, attr) {
          return event.originalEvent === undefined
            ? event[attr]
            : event.originalEvent[attr]
        },

        // Events
        /**
       * Get the X-coordinate or Y-coordinate of an event
       *
       * @param {Object} event  The event
       * @param targetTouchId The identifier of the touch with the X/Y coordinates
       * @returns {number}
       */
        getEventXY: function(event, targetTouchId) {
          /* http://stackoverflow.com/a/12336075/282882 */
          //noinspection JSLint
          var clientXY = this.options.vertical ? 'clientY' : 'clientX'
          if (event[clientXY] !== undefined) {
            return event[clientXY]
          }

          var touches = this.getEventAttr(event, 'touches')

          if (targetTouchId !== undefined) {
            for (var i = 0; i < touches.length; i++) {
              if (touches[i].identifier === targetTouchId) {
                return touches[i][clientXY]
              }
            }
          }

          // If no target touch or the target touch was not found in the event
          // returns the coordinates of the first touch
          return touches[0][clientXY]
        },

        /**
       * Compute the event position depending on whether the slider is horizontal or vertical
       * @param event
       * @param targetTouchId If targetTouchId is provided it will be considered the position of that
       * @returns {number}
       */
        getEventPosition: function(event, targetTouchId) {
          var sliderPos = this.sliderElem.rzsp,
            eventPos = 0
          if (this.options.vertical)
            eventPos = -this.getEventXY(event, targetTouchId) + sliderPos
          else eventPos = this.getEventXY(event, targetTouchId) - sliderPos
          return eventPos * this.options.scale - this.handleHalfDim // #346 handleHalfDim is already scaled
        },

        /**
       * Get event names for move and event end
       *
       * @param {Event}    event    The event
       *
       * @return {{moveEvent: string, endEvent: string}}
       */
        getEventNames: function(event) {
          var eventNames = {
            moveEvent: '',
            endEvent: ''
          }

          if (this.getEventAttr(event, 'touches')) {
            eventNames.moveEvent = 'touchmove'
            eventNames.endEvent = 'touchend'
          } else {
            eventNames.moveEvent = 'mousemove'
            eventNames.endEvent = 'mouseup'
          }

          return eventNames
        },

        /**
       * Get the handle closest to an event.
       *
       * @param event {Event} The event
       * @returns {jqLite} The handle closest to the event.
       */
        getNearestHandle: function(event) {
          if (!this.range) {
            return this.minH
          }
          var position = this.getEventPosition(event),
            distanceMin = Math.abs(position - this.minH.rzsp),
            distanceMax = Math.abs(position - this.maxH.rzsp)
          if (distanceMin < distanceMax) return this.minH
          else if (distanceMin > distanceMax) return this.maxH
          else if (!this.options.rightToLeft)
            //if event is at the same distance from min/max then if it's at left of minH, we return minH else maxH
            return position < this.minH.rzsp ? this.minH : this.maxH
          else
            //reverse in rtl
            return position > this.minH.rzsp ? this.minH : this.maxH
        },

        /**
       * Wrapper function to focus an angular element
       *
       * @param el {AngularElement} the element to focus
       */
        focusElement: function(el) {
          var DOM_ELEMENT = 0
          el[DOM_ELEMENT].focus()
        },

        /**
       * Bind mouse and touch events to slider handles
       *
       * @returns {undefined}
       */
        bindEvents: function() {
          var barTracking, barStart, barMove

          if (this.options.draggableRange) {
            barTracking = 'rzSliderDrag'
            barStart = this.onDragStart
            barMove = this.onDragMove
          } else {
            barTracking = 'lowValue'
            barStart = this.onStart
            barMove = this.onMove
          }

          if (!this.options.onlyBindHandles) {
            this.selBar.on(
              'mousedown',
              angular.bind(this, barStart, null, barTracking)
            )
            this.selBar.on(
              'mousedown',
              angular.bind(this, barMove, this.selBar)
            )
          }

          if (this.options.draggableRangeOnly) {
            this.minH.on(
              'mousedown',
              angular.bind(this, barStart, null, barTracking)
            )
            this.maxH.on(
              'mousedown',
              angular.bind(this, barStart, null, barTracking)
            )
          } else {
            this.minH.on(
              'mousedown',
              angular.bind(this, this.onStart, this.minH, 'lowValue')
            )
            if (this.range) {
              this.maxH.on(
                'mousedown',
                angular.bind(this, this.onStart, this.maxH, 'highValue')
              )
            }
            if (!this.options.onlyBindHandles) {
              this.fullBar.on(
                'mousedown',
                angular.bind(this, this.onStart, null, null)
              )
              this.fullBar.on(
                'mousedown',
                angular.bind(this, this.onMove, this.fullBar)
              )
              this.ticks.on(
                'mousedown',
                angular.bind(this, this.onStart, null, null)
              )
              this.ticks.on(
                'mousedown',
                angular.bind(this, this.onTickClick, this.ticks)
              )
            }
          }

          if (!this.options.onlyBindHandles) {
            this.selBar.on(
              'touchstart',
              angular.bind(this, barStart, null, barTracking)
            )
            this.selBar.on(
              'touchstart',
              angular.bind(this, barMove, this.selBar)
            )
          }
          if (this.options.draggableRangeOnly) {
            this.minH.on(
              'touchstart',
              angular.bind(this, barStart, null, barTracking)
            )
            this.maxH.on(
              'touchstart',
              angular.bind(this, barStart, null, barTracking)
            )
          } else {
            this.minH.on(
              'touchstart',
              angular.bind(this, this.onStart, this.minH, 'lowValue')
            )
            if (this.range) {
              this.maxH.on(
                'touchstart',
                angular.bind(this, this.onStart, this.maxH, 'highValue')
              )
            }
            if (!this.options.onlyBindHandles) {
              this.fullBar.on(
                'touchstart',
                angular.bind(this, this.onStart, null, null)
              )
              this.fullBar.on(
                'touchstart',
                angular.bind(this, this.onMove, this.fullBar)
              )
              this.ticks.on(
                'touchstart',
                angular.bind(this, this.onStart, null, null)
              )
              this.ticks.on(
                'touchstart',
                angular.bind(this, this.onTickClick, this.ticks)
              )
            }
          }

          if (this.options.keyboardSupport) {
            this.minH.on(
              'focus',
              angular.bind(this, this.onPointerFocus, this.minH, 'lowValue')
            )
            if (this.range) {
              this.maxH.on(
                'focus',
                angular.bind(this, this.onPointerFocus, this.maxH, 'highValue')
              )
            }
          }
        },

        /**
       * Unbind mouse and touch events to slider handles
       *
       * @returns {undefined}
       */
        unbindEvents: function() {
          this.minH.off()
          this.maxH.off()
          this.fullBar.off()
          this.selBar.off()
          this.ticks.off()
        },

        /**
       * onStart event handler
       *
       * @param {?Object} pointer The jqLite wrapped DOM element; if null, the closest handle is used
       * @param {?string} ref     The name of the handle being changed; if null, the closest handle's value is modified
       * @param {Event}   event   The event
       * @returns {undefined}
       */
        onStart: function(pointer, ref, event) {
          var ehMove,
            ehEnd,
            eventNames = this.getEventNames(event)

          event.stopPropagation()
          event.preventDefault()

          // We have to do this in case the HTML where the sliders are on
          // have been animated into view.
          this.calcViewDimensions()

          if (pointer) {
            this.tracking = ref
          } else {
            pointer = this.getNearestHandle(event)
            this.tracking = pointer === this.minH ? 'lowValue' : 'highValue'
          }

          pointer.addClass('rz-active')

          if (this.options.keyboardSupport) this.focusElement(pointer)

          ehMove = angular.bind(
            this,
            this.dragging.active ? this.onDragMove : this.onMove,
            pointer
          )
          ehEnd = angular.bind(this, this.onEnd, ehMove)

          $document.on(eventNames.moveEvent, ehMove)
          $document.on(eventNames.endEvent, ehEnd)
          this.endHandlerToBeRemovedOnEnd = ehEnd

          this.callOnStart()

          var changedTouches = this.getEventAttr(event, 'changedTouches')
          if (changedTouches) {
            // Store the touch identifier
            if (!this.touchId) {
              this.isDragging = true
              this.touchId = changedTouches[0].identifier
            }
          }
        },

        /**
       * onMove event handler
       *
       * @param {jqLite} pointer
       * @param {Event}  event The event
       * @param {boolean}  fromTick if the event occured on a tick or not
       * @returns {undefined}
       */
        onMove: function(pointer, event, fromTick) {
          var changedTouches = this.getEventAttr(event, 'changedTouches')
          var touchForThisSlider
          if (changedTouches) {
            for (var i = 0; i < changedTouches.length; i++) {
              if (changedTouches[i].identifier === this.touchId) {
                touchForThisSlider = changedTouches[i]
                break
              }
            }
          }

          if (changedTouches && !touchForThisSlider) {
            return
          }

          var newPos = this.getEventPosition(
              event,
              touchForThisSlider ? touchForThisSlider.identifier : undefined
            ),
            newValue,
            ceilValue = this.options.rightToLeft
              ? this.minValue
              : this.maxValue,
            flrValue = this.options.rightToLeft ? this.maxValue : this.minValue

          if (newPos <= 0) {
            newValue = flrValue
          } else if (newPos >= this.maxPos) {
            newValue = ceilValue
          } else {
            newValue = this.positionToValue(newPos)
            if (fromTick && angular.isNumber(this.options.showTicks))
              newValue = this.roundStep(newValue, this.options.showTicks)
            else newValue = this.roundStep(newValue)
          }
          this.positionTrackingHandle(newValue)
        },

        /**
       * onEnd event handler
       *
       * @param {Event}    event    The event
       * @param {Function} ehMove   The bound move event handler
       * @returns {undefined}
       */
        onEnd: function(ehMove, event) {
          var changedTouches = this.getEventAttr(event, 'changedTouches')
          if (changedTouches && changedTouches[0].identifier !== this.touchId) {
            return
          }
          this.isDragging = false
          this.touchId = null

          if (!this.options.keyboardSupport) {
            this.minH.removeClass('rz-active')
            this.maxH.removeClass('rz-active')
            this.tracking = ''
          }
          this.dragging.active = false

          var eventName = this.getEventNames(event)
          $document.off(eventName.moveEvent, ehMove)
          $document.off(eventName.endEvent, this.endHandlerToBeRemovedOnEnd)
          this.endHandlerToBeRemovedOnEnd = null
          this.callOnEnd()
        },

        onTickClick: function(pointer, event) {
          this.onMove(pointer, event, true)
        },

        onPointerFocus: function(pointer, ref) {
          this.tracking = ref
          pointer.one('blur', angular.bind(this, this.onPointerBlur, pointer))
          pointer.on('keydown', angular.bind(this, this.onKeyboardEvent))
          pointer.on('keyup', angular.bind(this, this.onKeyUp))
          this.firstKeyDown = true
          pointer.addClass('rz-active')

          this.currentFocusElement = {
            pointer: pointer,
            ref: ref
          }
        },

        onKeyUp: function() {
          this.firstKeyDown = true
          this.callOnEnd()
        },

        onPointerBlur: function(pointer) {
          pointer.off('keydown')
          pointer.off('keyup')
          pointer.removeClass('rz-active')
          if (!this.isDragging) {
            this.tracking = ''
            this.currentFocusElement = null
          }
        },

        /**
       * Key actions helper function
       *
       * @param {number} currentValue value of the slider
       *
       * @returns {?Object} action value mappings
       */
        getKeyActions: function(currentValue) {
          var increaseStep = currentValue + this.step,
            decreaseStep = currentValue - this.step,
            increasePage = currentValue + this.valueRange / 10,
            decreasePage = currentValue - this.valueRange / 10

          if (this.options.reversedControls) {
            increaseStep = currentValue - this.step
            decreaseStep = currentValue + this.step
            increasePage = currentValue - this.valueRange / 10
            decreasePage = currentValue + this.valueRange / 10
          }

          //Left to right default actions
          var actions = {
            UP: increaseStep,
            DOWN: decreaseStep,
            LEFT: decreaseStep,
            RIGHT: increaseStep,
            PAGEUP: increasePage,
            PAGEDOWN: decreasePage,
            HOME: this.options.reversedControls ? this.maxValue : this.minValue,
            END: this.options.reversedControls ? this.minValue : this.maxValue
          }
          //right to left means swapping right and left arrows
          if (this.options.rightToLeft) {
            actions.LEFT = increaseStep
            actions.RIGHT = decreaseStep
            // right to left and vertical means we also swap up and down
            if (this.options.vertical) {
              actions.UP = decreaseStep
              actions.DOWN = increaseStep
            }
          }
          return actions
        },

        onKeyboardEvent: function(event) {
          var currentValue = this[this.tracking],
            keyCode = event.keyCode || event.which,
            keys = {
              38: 'UP',
              40: 'DOWN',
              37: 'LEFT',
              39: 'RIGHT',
              33: 'PAGEUP',
              34: 'PAGEDOWN',
              36: 'HOME',
              35: 'END'
            },
            actions = this.getKeyActions(currentValue),
            key = keys[keyCode],
            action = actions[key]
          if (action == null || this.tracking === '') return
          event.preventDefault()

          if (this.firstKeyDown) {
            this.firstKeyDown = false
            this.callOnStart()
          }

          var self = this
          $timeout(function() {
            var newValue = self.roundStep(self.sanitizeValue(action))
            if (!self.options.draggableRangeOnly) {
              self.positionTrackingHandle(newValue)
            } else {
              var difference = self.highValue - self.lowValue,
                newMinValue,
                newMaxValue
              if (self.tracking === 'lowValue') {
                newMinValue = newValue
                newMaxValue = newValue + difference
                if (newMaxValue > self.maxValue) {
                  newMaxValue = self.maxValue
                  newMinValue = newMaxValue - difference
                }
              } else {
                newMaxValue = newValue
                newMinValue = newValue - difference
                if (newMinValue < self.minValue) {
                  newMinValue = self.minValue
                  newMaxValue = newMinValue + difference
                }
              }
              self.positionTrackingBar(newMinValue, newMaxValue)
            }
          })
        },

        /**
       * onDragStart event handler
       *
       * Handles dragging of the middle bar.
       *
       * @param {Object} pointer The jqLite wrapped DOM element
       * @param {string} ref     One of the refLow, refHigh values
       * @param {Event}  event   The event
       * @returns {undefined}
       */
        onDragStart: function(pointer, ref, event) {
          var position = this.getEventPosition(event)
          this.dragging = {
            active: true,
            value: this.positionToValue(position),
            difference: this.highValue - this.lowValue,
            lowLimit: this.options.rightToLeft
              ? this.minH.rzsp - position
              : position - this.minH.rzsp,
            highLimit: this.options.rightToLeft
              ? position - this.maxH.rzsp
              : this.maxH.rzsp - position
          }

          this.onStart(pointer, ref, event)
        },

        /**
       * getValue helper function
       *
       * gets max or min value depending on whether the newPos is outOfBounds above or below the bar and rightToLeft
       *
       * @param {string} type 'max' || 'min' The value we are calculating
       * @param {number} newPos  The new position
       * @param {boolean} outOfBounds Is the new position above or below the max/min?
       * @param {boolean} isAbove Is the new position above the bar if out of bounds?
       *
       * @returns {number}
       */
        getValue: function(type, newPos, outOfBounds, isAbove) {
          var isRTL = this.options.rightToLeft,
            value = null

          if (type === 'min') {
            if (outOfBounds) {
              if (isAbove) {
                value = isRTL
                  ? this.minValue
                  : this.maxValue - this.dragging.difference
              } else {
                value = isRTL
                  ? this.maxValue - this.dragging.difference
                  : this.minValue
              }
            } else {
              value = isRTL
                ? this.positionToValue(newPos + this.dragging.lowLimit)
                : this.positionToValue(newPos - this.dragging.lowLimit)
            }
          } else {
            if (outOfBounds) {
              if (isAbove) {
                value = isRTL
                  ? this.minValue + this.dragging.difference
                  : this.maxValue
              } else {
                value = isRTL
                  ? this.maxValue
                  : this.minValue + this.dragging.difference
              }
            } else {
              if (isRTL) {
                value =
                  this.positionToValue(newPos + this.dragging.lowLimit) +
                  this.dragging.difference
              } else {
                value =
                  this.positionToValue(newPos - this.dragging.lowLimit) +
                  this.dragging.difference
              }
            }
          }
          return this.roundStep(value)
        },

        /**
       * onDragMove event handler
       *
       * Handles dragging of the middle bar.
       *
       * @param {jqLite} pointer
       * @param {Event}  event The event
       * @returns {undefined}
       */
        onDragMove: function(pointer, event) {
          var newPos = this.getEventPosition(event),
            newMinValue,
            newMaxValue,
            ceilLimit,
            flrLimit,
            isUnderFlrLimit,
            isOverCeilLimit,
            flrH,
            ceilH

          if (this.options.rightToLeft) {
            ceilLimit = this.dragging.lowLimit
            flrLimit = this.dragging.highLimit
            flrH = this.maxH
            ceilH = this.minH
          } else {
            ceilLimit = this.dragging.highLimit
            flrLimit = this.dragging.lowLimit
            flrH = this.minH
            ceilH = this.maxH
          }
          isUnderFlrLimit = newPos <= flrLimit
          isOverCeilLimit = newPos >= this.maxPos - ceilLimit

          if (isUnderFlrLimit) {
            if (flrH.rzsp === 0) return
            newMinValue = this.getValue('min', newPos, true, false)
            newMaxValue = this.getValue('max', newPos, true, false)
          } else if (isOverCeilLimit) {
            if (ceilH.rzsp === this.maxPos) return
            newMaxValue = this.getValue('max', newPos, true, true)
            newMinValue = this.getValue('min', newPos, true, true)
          } else {
            newMinValue = this.getValue('min', newPos, false)
            newMaxValue = this.getValue('max', newPos, false)
          }
          this.positionTrackingBar(newMinValue, newMaxValue)
        },

        /**
       * Set the new value and position for the entire bar
       *
       * @param {number} newMinValue   the new minimum value
       * @param {number} newMaxValue   the new maximum value
       */
        positionTrackingBar: function(newMinValue, newMaxValue) {
          if (
            this.options.minLimit != null &&
            newMinValue < this.options.minLimit
          ) {
            newMinValue = this.options.minLimit
            newMaxValue = newMinValue + this.dragging.difference
          }
          if (
            this.options.maxLimit != null &&
            newMaxValue > this.options.maxLimit
          ) {
            newMaxValue = this.options.maxLimit
            newMinValue = newMaxValue - this.dragging.difference
          }

          this.lowValue = newMinValue
          this.highValue = newMaxValue
          this.applyLowValue()
          if (this.range) this.applyHighValue()
          this.applyModel(true)
          this.updateHandles('lowValue', this.valueToPosition(newMinValue))
          this.updateHandles('highValue', this.valueToPosition(newMaxValue))
        },

        /**
       * Set the new value and position to the current tracking handle
       *
       * @param {number} newValue new model value
       */
        positionTrackingHandle: function(newValue) {
          var valueChanged = false
          newValue = this.applyMinMaxLimit(newValue)
          if (this.range) {
            if (this.options.pushRange) {
              newValue = this.applyPushRange(newValue)
              valueChanged = true
            } else {
              if (this.options.noSwitching) {
                if (this.tracking === 'lowValue' && newValue > this.highValue)
                  newValue = this.applyMinMaxRange(this.highValue)
                else if (
                  this.tracking === 'highValue' &&
                  newValue < this.lowValue
                )
                  newValue = this.applyMinMaxRange(this.lowValue)
              }
              newValue = this.applyMinMaxRange(newValue)
              /* This is to check if we need to switch the min and max handles */
              if (this.tracking === 'lowValue' && newValue > this.highValue) {
                this.lowValue = this.highValue
                this.applyLowValue()
                this.applyModel()
                this.updateHandles(this.tracking, this.maxH.rzsp)
                this.updateAriaAttributes()
                this.tracking = 'highValue'
                this.minH.removeClass('rz-active')
                this.maxH.addClass('rz-active')
                if (this.options.keyboardSupport) this.focusElement(this.maxH)
                valueChanged = true
              } else if (
                this.tracking === 'highValue' &&
                newValue < this.lowValue
              ) {
                this.highValue = this.lowValue
                this.applyHighValue()
                this.applyModel()
                this.updateHandles(this.tracking, this.minH.rzsp)
                this.updateAriaAttributes()
                this.tracking = 'lowValue'
                this.maxH.removeClass('rz-active')
                this.minH.addClass('rz-active')
                if (this.options.keyboardSupport) this.focusElement(this.minH)
                valueChanged = true
              }
            }
          }

          if (this[this.tracking] !== newValue) {
            this[this.tracking] = newValue
            if (this.tracking === 'lowValue') this.applyLowValue()
            else this.applyHighValue()
            this.applyModel()
            this.updateHandles(this.tracking, this.valueToPosition(newValue))
            this.updateAriaAttributes()
            valueChanged = true
          }

          if (valueChanged) this.applyModel(true)
        },

        applyMinMaxLimit: function(newValue) {
          if (this.options.minLimit != null && newValue < this.options.minLimit)
            return this.options.minLimit
          if (this.options.maxLimit != null && newValue > this.options.maxLimit)
            return this.options.maxLimit
          return newValue
        },

        applyMinMaxRange: function(newValue) {
          var oppositeValue =
              this.tracking === 'lowValue' ? this.highValue : this.lowValue,
            difference = Math.abs(newValue - oppositeValue)
          if (this.options.minRange != null) {
            if (difference < this.options.minRange) {
              if (this.tracking === 'lowValue')
                return this.highValue - this.options.minRange
              else return this.lowValue + this.options.minRange
            }
          }
          if (this.options.maxRange != null) {
            if (difference > this.options.maxRange) {
              if (this.tracking === 'lowValue')
                return this.highValue - this.options.maxRange
              else return this.lowValue + this.options.maxRange
            }
          }
          return newValue
        },

        applyPushRange: function(newValue) {
          var difference =
              this.tracking === 'lowValue'
                ? this.highValue - newValue
                : newValue - this.lowValue,
            minRange =
              this.options.minRange !== null
                ? this.options.minRange
                : this.options.step,
            maxRange = this.options.maxRange
          // if smaller than minRange
          if (difference < minRange) {
            if (this.tracking === 'lowValue') {
              this.highValue = Math.min(newValue + minRange, this.maxValue)
              newValue = this.highValue - minRange
              this.applyHighValue()
              this.updateHandles(
                'highValue',
                this.valueToPosition(this.highValue)
              )
            } else {
              this.lowValue = Math.max(newValue - minRange, this.minValue)
              newValue = this.lowValue + minRange
              this.applyLowValue()
              this.updateHandles(
                'lowValue',
                this.valueToPosition(this.lowValue)
              )
            }
            this.updateAriaAttributes()
          } else if (maxRange !== null && difference > maxRange) {
            // if greater than maxRange
            if (this.tracking === 'lowValue') {
              this.highValue = newValue + maxRange
              this.applyHighValue()
              this.updateHandles(
                'highValue',
                this.valueToPosition(this.highValue)
              )
            } else {
              this.lowValue = newValue - maxRange
              this.applyLowValue()
              this.updateHandles(
                'lowValue',
                this.valueToPosition(this.lowValue)
              )
            }
            this.updateAriaAttributes()
          }
          return newValue
        },

        /**
       * Apply the model values using scope.$apply.
       * We wrap it with the internalChange flag to avoid the watchers to be called
       */
        applyModel: function(callOnChange) {
          this.internalChange = true
          this.scope.$apply()
          callOnChange && this.callOnChange()
          this.internalChange = false
        },

        /**
       * Call the onStart callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
        callOnStart: function() {
          if (this.options.onStart) {
            var self = this,
              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
            this.scope.$evalAsync(function() {
              self.options.onStart(
                self.options.id,
                self.scope.rzSliderModel,
                self.scope.rzSliderHigh,
                pointerType
              )
            })
          }
        },

        /**
       * Call the onChange callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
        callOnChange: function() {
          if (this.options.onChange) {
            var self = this,
              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
            this.scope.$evalAsync(function() {
              self.options.onChange(
                self.options.id,
                self.scope.rzSliderModel,
                self.scope.rzSliderHigh,
                pointerType
              )
            })
          }
        },

        /**
       * Call the onEnd callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
        callOnEnd: function() {
          if (this.options.onEnd) {
            var self = this,
              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
            this.scope.$evalAsync(function() {
              self.options.onEnd(
                self.options.id,
                self.scope.rzSliderModel,
                self.scope.rzSliderHigh,
                pointerType
              )
            })
          }
          this.scope.$emit('slideEnded')
        }
      }

      return Slider
    }])
    .directive('rzslider', ['RzSlider', function(RzSlider) {
      'use strict'

      return {
        restrict: 'AE',
        replace: true,
        scope: {
          rzSliderModel: '=?',
          rzSliderHigh: '=?',
          rzSliderOptions: '&?',
          rzSliderTplUrl: '@'
        },

        /**
       * Return template URL
       *
       * @param {jqLite} elem
       * @param {Object} attrs
       * @return {string}
       */
        templateUrl: function(elem, attrs) {
          //noinspection JSUnresolvedVariable
          return attrs.rzSliderTplUrl || 'rzSliderTpl.html'
        },

        link: function(scope, elem) {
          scope.slider = new RzSlider(scope, elem) //attach on scope so we can test it
        }
      }
    }])

  // IDE assist

  /**
   * @name ngScope
   *
   * @property {number} rzSliderModel
   * @property {number} rzSliderHigh
   * @property {Object} rzSliderOptions
   */

  /**
   * @name jqLite
   *
   * @property {number|undefined} rzsp rzslider label position position
   * @property {number|undefined} rzsd rzslider element dimension
   * @property {string|undefined} rzsv rzslider label value/text
   * @property {Function} css
   * @property {Function} text
   */

  /**
   * @name Event
   * @property {Array} touches
   * @property {Event} originalEvent
   */

  /**
   * @name ThrottleOptions
   *
   * @property {boolean} leading
   * @property {boolean} trailing
   */

  module.run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('rzSliderTpl.html',
    "<div class=rzslider><span class=\"rz-bar-wrapper rz-left-out-selection\"><span class=rz-bar></span></span> <span class=\"rz-bar-wrapper rz-right-out-selection\"><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-selection\" ng-style=barStyle></span></span> <span class=\"rz-pointer rz-pointer-min\" ng-style=minPointerStyle></span> <span class=\"rz-pointer rz-pointer-max\" ng-style=maxPointerStyle></span> <span class=\"rz-bubble rz-limit rz-floor\"></span> <span class=\"rz-bubble rz-limit rz-ceil\"></span> <span class=\"rz-bubble rz-model-value\"></span> <span class=\"rz-bubble rz-model-high\"></span> <span class=rz-bubble></span><ul ng-show=showTicks class=rz-ticks><li ng-repeat=\"t in ticks track by $index\" class=rz-tick ng-class=\"{'rz-selected': t.selected}\" ng-style=t.style ng-attr-uib-tooltip=\"{{ t.tooltip }}\" ng-attr-tooltip-placement={{t.tooltipPlacement}} ng-attr-tooltip-append-to-body=\"{{ t.tooltip ? true : undefined}}\"><span ng-if=\"t.value != null\" class=rz-tick-value ng-attr-uib-tooltip=\"{{ t.valueTooltip }}\" ng-attr-tooltip-placement={{t.valueTooltipPlacement}}>{{ t.value }}</span> <span ng-if=\"t.legend != null\" class=rz-tick-legend>{{ t.legend }}</span></li></ul></div>"
  );

}]);

  return module.name
})
;

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
module.exports = 'vcRecaptcha';


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

/**
 * @license angular-recaptcha build:2018-05-09
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2018 VividCortex
**/

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    ng.module('vcRecaptcha', []);

}(angular));

/*global angular */
(function (ng) {
    'use strict';

    function throwNoKeyException() {
        throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
    }

    var app = ng.module('vcRecaptcha');

    /**
     * An angular service to wrap the reCaptcha API
     */
    app.provider('vcRecaptchaService', function(){
        var provider = this;
        var config = {};
        provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param defaults  object which overrides the current defaults object.
         */
        provider.setDefaults = function(defaults){
            ng.copy(defaults, config);
        };

        /**
         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
         */
        provider.setSiteKey = function(siteKey){
            config.key = siteKey;
        };

        /**
         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param theme  The reCaptcha theme.
         */
        provider.setTheme = function(theme){
            config.theme = theme;
        };

        /**
         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param stoken  The reCaptcha stoken.
         */
        provider.setStoken = function(stoken){
            config.stoken = stoken;
        };

        /**
         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param size  The reCaptcha size.
         */
        provider.setSize = function(size){
            config.size = size;
        };

        /**
         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param type  The reCaptcha type.
         */
        provider.setType = function(type){
            config.type = type;
        };

        /**
         * Sets the reCaptcha language which will be used by default is not specified in a specific directive instance.
         *
         * @param lang  The reCaptcha language.
         */
        provider.setLang = function(lang){
            config.lang = lang;
        };

        /**
         * Sets the reCaptcha badge position which will be used by default if not specified in a specific directive instance.
         *
         * @param badge  The reCaptcha badge position.
         */
        provider.setBadge = function(badge){
            config.badge = badge;
        };

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
         */
        provider.setOnLoadFunctionName = function(onLoadFunctionName){
            provider.onLoadFunctionName = onLoadFunctionName;
        };

        provider.$get = ['$rootScope','$window', '$q', '$document', '$interval', function ($rootScope, $window, $q, $document, $interval) {
            var deferred = $q.defer(), promise = deferred.promise, instances = {}, recaptcha;

            $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];

            var callback = function () {
                recaptcha = $window.grecaptcha;

                deferred.resolve(recaptcha);
            };

            $window.vcRecaptchaApiLoadedCallback.push(callback);

            $window[provider.onLoadFunctionName] = function () {
                $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
                    callback();
                });
            };


            function getRecaptcha() {
                if (!!recaptcha) {
                    return $q.when(recaptcha);
                }

                return promise;
            }

            function validateRecaptchaInstance() {
                if (!recaptcha) {
                    throw new Error('reCaptcha has not been loaded yet.');
                }
            }

            function isRenderFunctionAvailable() {
                return ng.isFunction(($window.grecaptcha || {}).render);
            }


            // Check if grecaptcha.render is not defined already.
            if (isRenderFunctionAvailable()) {
                callback();
            } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
                // wait for script to be loaded.
                var intervalWait = $interval(function() {
                    if (isRenderFunctionAvailable()) {
                        $interval.cancel(intervalWait);
                        callback();
                    }
                }, 25);
            } else {
                // Generate link on demand
                var script = $window.document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://www.google.com/recaptcha/api.js?onload='+provider.onLoadFunctionName+'&render=explicit';
                $document.find('body')[0].appendChild(script);
            }

            return {

                /**
                 * Creates a new reCaptcha object
                 *
                 * @param elm  the DOM element where to put the captcha
                 * @param conf the captcha object configuration
                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
                 */
                create: function (elm, conf) {

                    conf.sitekey = conf.key || config.key;
                    conf.theme = conf.theme || config.theme;
                    conf.stoken = conf.stoken || config.stoken;
                    conf.size = conf.size || config.size;
                    conf.type = conf.type || config.type;
                    conf.hl = conf.lang || config.lang;
                    conf.badge = conf.badge || config.badge;

                    if (!conf.sitekey) {
                        throwNoKeyException();
                    }
                    return getRecaptcha().then(function (recaptcha) {
                        var widgetId = recaptcha.render(elm, conf);
                        instances[widgetId] = elm;
                        return widgetId;
                    });
                },

                /**
                 * Reloads the reCaptcha
                 */
                reload: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.reset(widgetId);

                    // Let everyone know this widget has been reset.
                    $rootScope.$broadcast('reCaptchaReset', widgetId);
                },

                /**
                 * Executes the reCaptcha
                 */
                execute: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.execute(widgetId);
                },

                /**
                 * Get/Set reCaptcha language
                 */
                useLang: function (widgetId, lang) {
                    var instance = instances[widgetId];

                    if (instance) {
                        var iframe = instance.querySelector('iframe');
                        if (lang) {
                            // Setter
                            if (iframe && iframe.src) {
                                var s = iframe.src;
                                if (/[?&]hl=/.test(s)) {
                                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
                                } else {
                                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
                                }

                                iframe.src = s;
                            }
                        } else {
                            // Getter
                            if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
                                return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
                            } else {
                                return null;
                            }
                        }
                    } else {
                        throw new Error('reCaptcha Widget ID not exists', widgetId);
                    }
                },

                /**
                 * Gets the response from the reCaptcha widget.
                 *
                 * @see https://developers.google.com/recaptcha/docs/display#js_api
                 *
                 * @returns {String}
                 */
                getResponse: function (widgetId) {
                    validateRecaptchaInstance();

                    return recaptcha.getResponse(widgetId);
                },

                /**
                 * Gets reCaptcha instance and configuration
                 */
                getInstance: function (widgetId) {
                    return instances[widgetId];
                },

                /**
                 * Destroy reCaptcha instance.
                 */
                destroy: function (widgetId) {
                    delete instances[widgetId];
                }
            };

        }];
    });

}(angular));

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    var app = ng.module('vcRecaptcha');

    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function ($document, $timeout, vcRecaptcha) {

        return {
            restrict: 'A',
            require: "?^^form",
            scope: {
                response: '=?ngModel',
                key: '=?',
                stoken: '=?',
                theme: '=?',
                size: '=?',
                type: '=?',
                lang: '=?',
                badge: '=?',
                tabindex: '=?',
                required: '=?',
                onCreate: '&',
                onSuccess: '&',
                onExpire: '&'
            },
            link: function (scope, elm, attrs, ctrl) {
                scope.widgetId = null;

                if(ctrl && ng.isDefined(attrs.required)){
                    scope.$watch('required', validate);
                }

                var removeCreationListener = scope.$watch('key', function (key) {
                    var callback = function (gRecaptchaResponse) {
                        // Safe $apply
                        $timeout(function () {
                            scope.response = gRecaptchaResponse;
                            validate();

                            // Notify about the response availability
                            scope.onSuccess({response: gRecaptchaResponse, widgetId: scope.widgetId});
                        });
                    };

                    vcRecaptcha.create(elm[0], {

                        callback: callback,
                        key: key,
                        stoken: scope.stoken || attrs.stoken || null,
                        theme: scope.theme || attrs.theme || null,
                        type: scope.type || attrs.type || null,
                        lang: scope.lang || attrs.lang || null,
                        tabindex: scope.tabindex || attrs.tabindex || null,
                        size: scope.size || attrs.size || null,
                        badge: scope.badge || attrs.badge || null,
                        'expired-callback': expired

                    }).then(function (widgetId) {
                        // The widget has been created
                        validate();
                        scope.widgetId = widgetId;
                        scope.onCreate({widgetId: widgetId});

                        scope.$on('$destroy', destroy);

                        scope.$on('reCaptchaReset', function(event, resetWidgetId){
                          if(ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId){
                            scope.response = "";
                            validate();
                          }
                        })

                    });

                    // Remove this listener to avoid creating the widget more than once.
                    removeCreationListener();
                });

                function destroy() {
                  if (ctrl) {
                    // reset the validity of the form if we were removed
                    ctrl.$setValidity('recaptcha', null);
                  }

                  cleanup();
                }

                function expired(){
                    // Safe $apply
                    $timeout(function () {
                        scope.response = "";
                        validate();

                        // Notify about the response availability
                        scope.onExpire({ widgetId: scope.widgetId });
                    });
                }

                function validate(){
                    if(ctrl){
                        ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
                    }
                }

                function cleanup(){
                  vcRecaptcha.destroy(scope.widgetId);

                  // removes elements reCaptcha added.
                  ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
                }
            }
        };
    }]);

}(angular));


/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_kalkulator_pcss__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_kalkulator_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kalkulator_kalkulator_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kalkulator_kalkulator_module_js__ = __webpack_require__(300);



/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_form_pug__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_form_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kalkulator_form_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_native_accessible_select_native_accessible_select__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_tooltip_tooltip__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_tipus_base__ = __webpack_require__(105);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorFormComponent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DEFAULT_AGE = 25;
var DEFAULT_MONTHLY_PAYMENT = 10000;
var DEFAULT_EXPECTED_YIELD = 4;
var DEFAULT_MONTHLY_ANNUITY = 10000;
var DEFAULT_YEARS = 10;
var KalkulatorFormComponent = {
  template: __WEBPACK_IMPORTED_MODULE_0__kalkulator_form_pug___default()(),
  transclude: {
    tooltipFormContent: "tooltipFormContent"
  },
  bindings: {
    tipus: "<",
    hozamok: "<",
    vegpontok: "<",
    onCalculate: "&",
    onTabChange: "&"
  },
  controller: function (_TipusBase) {
    KalkulatorFormController.$inject = ["$scope", "$timeout", "$element"];

    _inherits(KalkulatorFormController, _TipusBase);

    function KalkulatorFormController($scope, $timeout, $element) {
      "ngInject";

      _classCallCheck(this, KalkulatorFormController);

      var _this = _possibleConstructorReturn(this, _TipusBase.call(this));

      _this.$timeout = $timeout;
      _this.$element = $element[0];
      $scope.$watch("$ctrl.expectedYieldTab1", function (val) {
        _this.expectedYieldInput = val;
      });
      $scope.$watch("$ctrl.model.age", function (val) {
        _this.ageInput = val;
        _this.vegpontok && _this.isJaradek() && _this._setSliderLimits();
      });
      $scope.$watch("$ctrl.vegpontok", function (val) {
        if (val) {
          _this._setSliderLimits();
        }
      });

      $scope.$watch("$ctrl.ageInput", function (val) {
        if (val) {
          _this.model.age = _this.ageInput;
        } else {
          _this.model.age = DEFAULT_AGE;
          _this.ageInput = DEFAULT_AGE;
        }
      });
      $scope.$watch("$ctrl.model.years", function (val) {
        _this.yearsInput = val;
      });
      $scope.$watch("$ctrl.yearsInput", function (val) {
        if (val) {
          _this.model.years = _this.yearsInput;
        } else {
          _this.yearsInput = DEFAULT_YEARS;
          _this.model.years = DEFAULT_YEARS;
        }
      });
      $scope.$watch("$ctrl.expectedYieldInput", function (val) {
        if (val) {
          _this.expectedYieldTab1 = _this.expectedYieldInput;
        } else {
          _this.expectedYieldTab1 = DEFAULT_EXPECTED_YIELD;
          _this.expectedYieldInput = DEFAULT_EXPECTED_YIELD;
        }
      });
      $scope.$watch("$ctrl.model.monthlyPayment", function (val) {
        _this.monthlyPaymentInput = val;
      });
      $scope.$watch("$ctrl.model.monthlyAnnuity", function (val) {
        _this.monthlyAnnuityInput = val;
      });
      $scope.$watch("$ctrl.activeTab", function (val) {
        _this.kalkulatorForm.$setUntouched();
        _this.kalkulatorForm.$setPristine();

        _this.onTabChange();
        if (val == 1 || val == 2) {
          _this.model.customYield = false;
          setTimeout(function () {
            var selects = Array.from(_this.$element.querySelectorAll("select"));
            selects.forEach(function (item) {
              setTimeout(function () {
                new __WEBPACK_IMPORTED_MODULE_1__common_native_accessible_select_native_accessible_select__["a" /* default */]({ element: item });
              }, 0);
            });
          }, 0);
        } else {
          _this.model.customYield = true;
        }
      });
      return _this;
    }

    KalkulatorFormController.prototype.$onInit = function $onInit() {
      var _this2 = this;

      this.model = {
        age: DEFAULT_AGE
      };
      this.activeTab = "0";
      if (this.isMegtakaritas()) {
        this.model.monthlyPayment = DEFAULT_MONTHLY_PAYMENT;
        this.monthlyPaymentInput = this.model.monthlyPayment;
      }
      if (this.isJaradek()) {
        this.model.monthlyAnnuity = DEFAULT_MONTHLY_ANNUITY;
        this.model.years = DEFAULT_YEARS;
        this.yearsInput = this.model.years;
        this.monthlyAnnuityInput = this.model.monthlyAnnuity;
      }
      this.expectedYieldTab1 = DEFAULT_EXPECTED_YIELD;
      this.expectedYieldInput = this.expectedYieldTab1;
      this.ageInput = this.model.age;
      this.ageOptions = {
        floor: 16,
        ceil: 60,
        minLimit: 16,
        maxLimit: 60,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false
      };
      this.yearsOptions = {
        floor: 5,
        ceil: 45,
        minLimit: 5,
        maxLimit: 45,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false
      };
      this.monthlyPaymentOptions = {
        floor: 10000,
        ceil: 100000,
        minLimit: 10000,
        maxLimit: 100000,
        step: 1000,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false
      };
      this.monthlyAnnuityOptions = {
        floor: 5000,
        ceil: 400000,
        minLimit: 5000,
        maxLimit: 400000,
        step: 5000,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false
      };
      this.expectedYieldOptions = {
        floor: 1,
        ceil: 14,
        minLimit: 1,
        maxLimit: 14,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false
      };
      setTimeout(function () {
        var tooltips = Array.from(_this2.$element.querySelectorAll(".tooltip"));
        tooltips.forEach(function (item) {
          setTimeout(function () {
            new __WEBPACK_IMPORTED_MODULE_2__common_tooltip_tooltip__["a" /* tooltipHack */]();
          }, 0);
        });
      }, 0);
    };

    KalkulatorFormController.prototype._setSliderLimits = function _setSliderLimits() {
      var _this3 = this;

      // megkeresi azt a vegpontot ahol a beallitott eletkor kisebb mint a kovetkezo sor
      if (this.isJaradek()) {
        var vegpont = this.vegpontok.find(function (item, index, array) {
          return array[index + 1] && array[index + 1].age > _this3.model.age || typeof array[index + 1] == "undefined";
        });
        this.yearsOptions.floor = this.yearsOptions.minLimit = vegpont.minimumAnnuityYears;
        this.monthlyAnnuityOptions.floor = this.monthlyAnnuityOptions.minLimit = vegpont.minimumAnnuityAmount;
        this.expectedYieldOptions.ceil = this.expectedYieldOptions.maxLimit = vegpont.maximumYield;
        this.monthlyPaymentOptions.floor = this.monthlyPaymentOptions.minLimit = vegpont.minimumPayment;
      }
    };

    KalkulatorFormController.prototype.onMonthlyPaymentBlur = function onMonthlyPaymentBlur(val) {
      var _this4 = this;

      if (val) {
        this.model.monthlyPayment = val;
      } else {
        this.model.monthlyPayment = DEFAULT_MONTHLY_PAYMENT;
      }
      this.$timeout(function () {
        _this4.monthlyPaymentInput = _this4.model.monthlyPayment;
      });
    };

    KalkulatorFormController.prototype.onMonthlyAnnuityBlur = function onMonthlyAnnuityBlur(val) {
      var _this5 = this;

      if (val) {
        this.model.monthlyAnnuity = val;
      } else {
        this.model.monthlyAnnuity = DEFAULT_MONTHLY_ANNUITY;
      }
      this.$timeout(function () {
        _this5.monthlyAnnuityInput = _this5.model.monthlyAnnuity;
      });
    };

    KalkulatorFormController.prototype.isMonthlyAnnuityMinusDisabled = function isMonthlyAnnuityMinusDisabled() {
      return this.model.monthlyAnnuity == this.monthlyAnnuityOptions.floor;
    };

    KalkulatorFormController.prototype.isMonthlyAnnuityPlusDisabled = function isMonthlyAnnuityPlusDisabled() {
      return this.model.monthlyAnnuity == this.monthlyAnnuityOptions.ceil;
    };

    KalkulatorFormController.prototype.decreaseMonthlyAnnuity = function decreaseMonthlyAnnuity() {
      this.model.monthlyAnnuity -= this.monthlyAnnuityOptions.step;
    };

    KalkulatorFormController.prototype.increaseMonthlyAnnuity = function increaseMonthlyAnnuity() {
      this.model.monthlyAnnuity += this.monthlyAnnuityOptions.step;
    };

    KalkulatorFormController.prototype.isAgeMinusDisabled = function isAgeMinusDisabled() {
      return this.model.age == this.ageOptions.floor;
    };

    KalkulatorFormController.prototype.isAgePlusDisabled = function isAgePlusDisabled() {
      return this.model.age == this.ageOptions.ceil;
    };

    KalkulatorFormController.prototype.decreaseAge = function decreaseAge() {
      this.model.age--;
    };

    KalkulatorFormController.prototype.increaseAge = function increaseAge() {
      this.model.age++;
    };

    KalkulatorFormController.prototype.isYearsMinusDisabled = function isYearsMinusDisabled() {
      return this.model.years == this.yearsOptions.floor;
    };

    KalkulatorFormController.prototype.isYearsPlusDisabled = function isYearsPlusDisabled() {
      return this.model.years == this.yearsOptions.ceil;
    };

    KalkulatorFormController.prototype.decreaseYears = function decreaseYears() {
      this.model.years--;
    };

    KalkulatorFormController.prototype.increaseYears = function increaseYears() {
      this.model.years++;
    };

    KalkulatorFormController.prototype.isExpectedYieldMinusDisabled = function isExpectedYieldMinusDisabled() {
      return this.expectedYieldTab1 == this.expectedYieldOptions.floor;
    };

    KalkulatorFormController.prototype.isExpectedYieldPlusDisabled = function isExpectedYieldPlusDisabled() {
      return this.expectedYieldTab1 == this.expectedYieldOptions.ceil;
    };

    KalkulatorFormController.prototype.decreaseExpectedYield = function decreaseExpectedYield() {
      this.expectedYieldTab1--;
    };

    KalkulatorFormController.prototype.increaseExpectedYield = function increaseExpectedYield() {
      this.expectedYieldTab1++;
    };

    KalkulatorFormController.prototype.isMonthlyPaymentMinusDisabled = function isMonthlyPaymentMinusDisabled() {
      return this.model.monthlyPayment == this.monthlyPaymentOptions.floor;
    };

    KalkulatorFormController.prototype.isMonthlyPaymentPlusDisabled = function isMonthlyPaymentPlusDisabled() {
      return this.model.monthlyPayment == this.monthlyPaymentOptions.ceil;
    };

    KalkulatorFormController.prototype.decreaseMonthlyPayment = function decreaseMonthlyPayment() {
      this.model.monthlyPayment -= this.monthlyPaymentOptions.step;
    };

    KalkulatorFormController.prototype.increaseMonthlyPayment = function increaseMonthlyPayment() {
      this.model.monthlyPayment += this.monthlyPaymentOptions.step;
    };

    KalkulatorFormController.prototype.calculate = function calculate() {
      if (this.kalkulatorForm.$valid) {
        var data = void 0;
        var expectedYield = void 0;
        switch (this.activeTab) {
          case "0":
            expectedYield = this.expectedYieldTab1;
            break;
          case "1":
            expectedYield = this.expectedYieldTab2;
            break;
          case "2":
            expectedYield = this.expectedYieldTab3;
            break;
        }
        data = Object.assign({}, this.model, { expectedYield: expectedYield });
        this.onCalculate({ data: data });
      }
    };

    return KalkulatorFormController;
  }(__WEBPACK_IMPORTED_MODULE_3__lib_tipus_base__["c" /* default */])
};

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_form_component__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_directives_ezresbontas_ezresbontas__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angularjs_slider__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angularjs_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angularjs_slider__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorFormModule; });



var KalkulatorFormModule = angular.module('kalkulatorForm', [__WEBPACK_IMPORTED_MODULE_1__common_directives_ezresbontas_ezresbontas__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_angularjs_slider___default.a]).component('kalkulatorForm', __WEBPACK_IMPORTED_MODULE_0__kalkulator_form_component__["a" /* KalkulatorFormComponent */]).name;

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_result_pug__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_result_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kalkulator_result_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_tooltip_tooltip__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_tipus_base__ = __webpack_require__(105);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorResultComponent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var KalkulatorResultComponent = {
	template: __WEBPACK_IMPORTED_MODULE_0__kalkulator_result_pug___default()(),
	transclude: {
		tooltipResultContent: 'tooltipResultContent'
	},
	bindings: {
		eredmeny: '<',
		tipus: '<'
	},
	controller: function (_TipusBase) {
		KalkulatorResultController.$inject = ['$element'];

		_inherits(KalkulatorResultController, _TipusBase);

		function KalkulatorResultController($element) {
			'ngInject';

			_classCallCheck(this, KalkulatorResultController);

			var _this = _possibleConstructorReturn(this, _TipusBase.call(this));

			_this.$element = $element[0];
			return _this;
		}

		KalkulatorResultController.prototype.$onInit = function $onInit() {
			var _this2 = this;

			setTimeout(function () {
				var tooltips = Array.from(_this2.$element.querySelectorAll('.tooltip'));
				tooltips.forEach(function (item) {
					setTimeout(function () {
						new __WEBPACK_IMPORTED_MODULE_1__common_tooltip_tooltip__["a" /* tooltipHack */]();
					}, 0);
				});
			}, 0);
		};

		KalkulatorResultController.prototype.getPdfUrl = function getPdfUrl() {
			var apiType = this.isMegtakaritas() ? 'megtakaritas' : 'jaradek';
			var url = '';
			if (this.eredmeny) {
				url = '/api/kalkulator/' + apiType + '/pdf/' + this.eredmeny.id;
			}
			return url;
		};

		return KalkulatorResultController;
	}(__WEBPACK_IMPORTED_MODULE_2__lib_tipus_base__["c" /* default */])
};

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_result_component__ = __webpack_require__(544);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorResultModule; });

var KalkulatorResultModule = angular.module('kalkulatorResult', []).component('kalkulatorResult', __WEBPACK_IMPORTED_MODULE_0__kalkulator_result_component__["a" /* KalkulatorResultComponent */]).name;

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_vhk_pug__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_vhk_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kalkulator_vhk_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_native_accessible_select_native_accessible_select__ = __webpack_require__(53);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorVhkComponent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var KalkulatorVhkComponent = {
	template: __WEBPACK_IMPORTED_MODULE_0__kalkulator_vhk_pug___default()(),
	bindings: {
		id: '@',
		visszahivasIdok: '<',
		success: '<',
		onPostForm: '&'
	},
	controller: function () {
		KalkulatorVhkController.$inject = ['$element', 'vcRecaptchaService'];

		function KalkulatorVhkController($element, vcRecaptchaService) {
			'ngInject';

			_classCallCheck(this, KalkulatorVhkController);

			this.$element = $element[0];
			this.vcRecaptchaService = vcRecaptchaService;
		}

		KalkulatorVhkController.prototype.$onInit = function $onInit() {
			var _this = this;

			this.model = {};
			this.patterns = {
				email: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["a" /* EMAIL_PATTERN */],
				phone: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["b" /* PHONE_PATTERN */],
				simpleText: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["c" /* SIMPLE_TEXT_PATTERN */],
				number: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["d" /* NUMBER_PATTERN */],
				membership: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["f" /* MEMBERSHIP_PATTERN */]
			};
			setTimeout(function () {
				var selects = Array.from(_this.$element.querySelectorAll('select'));
				selects.forEach(function (item) {
					setTimeout(function () {
						new __WEBPACK_IMPORTED_MODULE_2__common_native_accessible_select_native_accessible_select__["a" /* default */]({ element: item });
					}, 0);
				});
			}, 0);
		};

		KalkulatorVhkController.prototype.postContactForm = function postContactForm() {
			if (this.visszahivasKeresForm.$valid) {
				this.onPostForm({
					data: this.model
				});
			}
		};

		return KalkulatorVhkController;
	}()
};

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_vhk_component__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_recaptcha__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_recaptcha__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorVhkModule; });


var KalkulatorVhkModule = angular.module('kalkulatorVhk', [__WEBPACK_IMPORTED_MODULE_1_angular_recaptcha___default.a]).component('kalkulatorVhk', __WEBPACK_IMPORTED_MODULE_0__kalkulator_vhk_component__["a" /* KalkulatorVhkComponent */]).name;

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_pug__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kalkulator_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kalkulator_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_tipus_base__ = __webpack_require__(105);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorComponent; });
var _KALKULACIO_METODUSOK;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var KALKULACIO_METODUSOK = (_KALKULACIO_METODUSOK = {}, _KALKULACIO_METODUSOK[__WEBPACK_IMPORTED_MODULE_1__lib_tipus_base__["a" /* MEGTAKARITAS_TIPUS */]] = 'megtakaritasKalkulacio', _KALKULACIO_METODUSOK[__WEBPACK_IMPORTED_MODULE_1__lib_tipus_base__["b" /* JARADEK_TIPUS */]] = 'jaradekKalkulacio', _KALKULACIO_METODUSOK);
var KalkulatorComponent = {
	template: __WEBPACK_IMPORTED_MODULE_0__kalkulator_pug___default()(),
	transclude: {
		tooltipFormContent: 'tooltipFormContent',
		tooltipResultContent: 'tooltipResultContent'
	},
	bindings: {
		tipus: '@'
	},
	controller: function () {
		KalkulatorController.$inject = ['KalkulatorService', '$timeout', '$rootScope'];

		function KalkulatorController(KalkulatorService, $timeout, $rootScope) {
			'ngInject';

			_classCallCheck(this, KalkulatorController);

			this.kalkulatorService = KalkulatorService;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
		}

		KalkulatorController.prototype.$onInit = function $onInit() {
			this.init();
		};

		KalkulatorController.prototype.init = function init() {
			var _this = this;

			this.kalkulatorService.init().then(function (response) {
				_this.hozamok = response.hozamok;
				_this.visszahivasIdok = response.visszahivasIdok;
				_this.vegpontok = response.vegpontok;
			}).catch(function (err) {
				_this.$rootScope.$broadcast('serverError');
			});
		};

		KalkulatorController.prototype.resetResults = function resetResults() {
			this.eredmeny = null;
		};

		KalkulatorController.prototype.calculate = function calculate(data) {
			var _this2 = this;

			var kalkulacioMetodus = KALKULACIO_METODUSOK[this.tipus];
			this.kalkulatorService[kalkulacioMetodus](data).then(function (response) {
				_this2.eredmeny = response;
				_this2.$timeout(function () {
					document.getElementById('kalkulator-result').scrollIntoView();
				});
			}).catch(function (err) {
				_this2.$rootScope.$broadcast('serverError');
			});
		};

		KalkulatorController.prototype.sendVhk = function sendVhk(data) {
			var _this3 = this;

			var dataToSend = Object.assign({}, data, { calculationId: this.eredmeny.id });
			this.kalkulatorService.sendVhk(dataToSend).then(function (response) {
				_this3.vhkSuccess = true;
			}).catch(function (err) {
				_this3.$rootScope.$broadcast('serverError');
			});
		};

		return KalkulatorController;
	}()
};

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KalkulatorService; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KalkulatorService = function () {
	KalkulatorService.$inject = ['$http'];

	function KalkulatorService($http) {
		'ngInject';

		_classCallCheck(this, KalkulatorService);

		this.$http = $http;
	}

	KalkulatorService.prototype.init = function init() {
		return this.$http.get('/api/kalkulator/init').then(function (response) {
			return response.data;
		});
	};

	KalkulatorService.prototype.megtakaritasKalkulacio = function megtakaritasKalkulacio(data) {
		return this.$http.post('/api/kalkulator/megtakaritas', data).then(function (response) {
			return response.data;
		});
	};

	KalkulatorService.prototype.jaradekKalkulacio = function jaradekKalkulacio(data) {
		return this.$http.post('/api/kalkulator/jaradek', data).then(function (response) {
			return response.data;
		});
	};

	KalkulatorService.prototype.sendVhk = function sendVhk(data) {
		var captchaValue = data.captchaValue;
		delete data.captchaValue;
		return this.$http.post('/api/visszahivas/kalkulator', data, {
			headers: {
				'captcha': captchaValue
			}
		}).then(function (response) {
			return response.data;
		});
	};

	return KalkulatorService;
}();

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MODULE_NAME = 'ezresBontas';
/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).directive('ezresBontas', ['$filter', function ($filter) {
	'ngInject';

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function link(scope, element, attrs, ngModel) {
			var tortSzam = attrs.ezresBontas;
			if (ngModel) {
				ngModel.$formatters.unshift(function () {
					//convert data from model format to view format
					return $filter('number')(ngModel.$modelValue);
				});
				ngModel.$parsers.unshift(function (viewValue) {
					//convert data from view format to model format
					var convertableNumber = void 0;
					var viewNumber = void 0;
					viewNumber = tortSzam ? viewValue.replace(/[^0-9|,]/g, '') : viewValue.replace(/[^0-9]/g, '');
					convertableNumber = viewValue;
					if ((viewNumber.match(/,/g) || []).length == 2) {
						viewNumber = viewNumber.slice(0, -1);
						convertableNumber = convertableNumber.slice(0, -1);
					}
					if (viewNumber.slice(-1) == ',') {
						convertableNumber = viewValue + '0';
					}
					convertableNumber = tortSzam ? convertableNumber.replace(/[^0-9|,]/g, '').replace(/,/g, '.').replace(/\s/g, '') : convertableNumber.replace(/[^0-9]/g, '').replace(/\s/g, '');
					var a = $filter('number')(convertableNumber);
					var b = viewNumber.slice(-1) == ',' ? ',' : '';
					ngModel.$setViewValue('' + a + b);
					ngModel.$render();
					return convertableNumber;
				});
			}
		}
	};
}]).name);

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"kalkulator-form\" name=\"$ctrl.kalkulatorForm\" novalidate\u003E\u003Cdiv class=\"row form__row slider-row\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__age\"\u003EÉletkor:\u003C\u002Flabel\u003E\u003Cinput class=\"form-input form-input--input-xsmall\" id=\"kalkulator-form__age\" type=\"number\" ng-model=\"$ctrl.ageInput\" ng-model-options=\"{ updateOn: 'blur'}\"\u003E\u003Cspan\u003E\u003Cstrong\u003EÉv\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5 form-input__group\"\u003E\u003Clabel class=\"sr-only\" for=\"kalkulator-form__age-range\"\u003EÉletkor csúszka:\u003C\u002Flabel\u003E\u003Cbutton class=\"button__slider-steps negative\" type=\"button\" ng-click=\"$ctrl.decreaseAge()\" ng-disabled=\"$ctrl.isAgeMinusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték csökkentése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Crzslider id=\"kalkulator-form__age-range\" rz-slider-model=\"$ctrl.model.age\" rz-slider-options=\"$ctrl.ageOptions\"\u003E\u003C\u002Frzslider\u003E\u003Cbutton class=\"button__slider-steps positive\" type=\"button\" ng-click=\"$ctrl.increaseAge()\" ng-disabled=\"$ctrl.isAgePlusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték növelése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row slider-row\" ng-if=\"$ctrl.isJaradek()\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__allowance-amount\" aria-describedby=\"tooltip__allowance-amount\"\u003EHavi járadék összege:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tooltip__allowance-amount\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content\"\u003E\u003Cp\u003EAdja meg, az igényelt havi nyugdíj-kiegészítés, járadék összegét!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput class=\"form-input form-input--input-xsmall\" id=\"kalkulator-form__allowance-amount\" type=\"tel\" maxlength=\"7\" min=\"5000\" max=\"100000\" value=\"10000\" ng-model=\"$ctrl.monthlyAnnuityInput\" ng-blur=\"$ctrl.onMonthlyAnnuityBlur($ctrl.monthlyAnnuityInput)\" ezres-bontas=\"\"\u003E\u003Cspan\u003E\u003Cstrong\u003EFt\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5 form-input__group\"\u003E\u003Clabel class=\"sr-only\" for=\"kalkulator-form__allowance-amount-range\"\u003EHavi járadék összege csúszka:\u003C\u002Flabel\u003E\u003Cbutton class=\"button__slider-steps negative\" type=\"button\" ng-click=\"$ctrl.decreaseMonthlyAnnuity()\" ng-disabled=\"$ctrl.isMonthlyAnnuityMinusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték csökkentése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Crzslider id=\"kalkulator-form__allowance-amount-range\" rz-slider-model=\"$ctrl.model.monthlyAnnuity\" rz-slider-options=\"$ctrl.monthlyAnnuityOptions\"\u003E\u003C\u002Frzslider\u003E\u003Cbutton class=\"button__slider-steps positive\" type=\"button\" ng-click=\"$ctrl.increaseMonthlyAnnuity()\" ng-disabled=\"$ctrl.isMonthlyAnnuityPlusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték növelése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row slider-row\" ng-if=\"$ctrl.isJaradek()\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__annuity\" aria-describedby=\"tooltip__annuity\"\u003EJáradék év:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tooltip__annuity\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content\"\u003E\u003Cp\u003EAdja meg, hány évig szeretne nyugdíj-kiegészítést kapni!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput class=\"form-input form-input--input-xsmall\" id=\"kalkulator-form__annuity\" type=\"number\" ng-model=\"$ctrl.yearsInput\" ng-model-options=\"{ updateOn: 'blur'}\"\u003E\u003Cspan\u003E\u003Cstrong\u003EÉv\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5 form-input__group\"\u003E\u003Clabel class=\"sr-only\" for=\"kalkulator-form__annuity-range\"\u003EJáradék év csúszka:\u003C\u002Flabel\u003E\u003Cbutton class=\"button__slider-steps negative\" type=\"button\" ng-click=\"$ctrl.decreaseYears()\" ng-disabled=\"$ctrl.isYearsMinusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték csökkentése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Crzslider id=\"kalkulator-form__annuity-range\" rz-slider-model=\"$ctrl.model.years\" rz-slider-options=\"$ctrl.yearsOptions\"\u003E\u003C\u002Frzslider\u003E\u003Cbutton class=\"button__slider-steps positive\" type=\"button\" ng-click=\"$ctrl.increaseYears()\" ng-disabled=\"$ctrl.isYearsPlusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték növelése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row slider-row\" ng-if=\"$ctrl.isMegtakaritas()\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__deposit\" aria-describedby=\"tooltip__deposit\"\u003EHavi befizetés:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tooltip__deposit\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content\"\u003E\u003Cp\u003EEgységes, minimális havi tagdíj 10.000 Ft\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput class=\"form-input form-input--input-xsmall\" id=\"kalkulator-form__deposit\" type=\"tel\" maxlength=\"7\" min=\"5000\" max=\"100000\" value=\"10000\" ng-model=\"$ctrl.monthlyPaymentInput\" ng-blur=\"$ctrl.onMonthlyPaymentBlur($ctrl.monthlyPaymentInput)\" ezres-bontas=\"\"\u003E\u003Cspan\u003E\u003Cstrong\u003EFt\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5 form-input__group\"\u003E\u003Clabel class=\"sr-only\" for=\"kalkulator-form__deposit-range\"\u003EHavi befizetés csúszka:\u003C\u002Flabel\u003E\u003Cbutton class=\"button__slider-steps negative\" type=\"button\" ng-click=\"$ctrl.decreaseMonthlyPayment()\" ng-disabled=\"$ctrl.isMonthlyPaymentMinusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték csökkentése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Crzslider id=\"kalkulator-form__deposit-range\" rz-slider-model=\"$ctrl.model.monthlyPayment\" rz-slider-options=\"$ctrl.monthlyPaymentOptions\"\u003E\u003C\u002Frzslider\u003E\u003Cbutton class=\"button__slider-steps positive\" type=\"button\" ng-click=\"$ctrl.increaseMonthlyPayment()\" ng-disabled=\"$ctrl.isMonthlyPaymentPlusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték növelése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cfieldset class=\"kalkulator-form__choose-box\"\u003E\u003Clegend class=\"kalkulator-form__choose-title\" aria-describedby=\"tooltip__choose-title\"\u003EHozamelvárás\u003Cspan class=\"tooltip\" id=\"tooltip__choose-title\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cspan class=\"tooltip-content\"\u003EAdja meg, a kalkulátor hány százalék nettó hozammal számoljon!\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Flegend\u003E\u003Cdiv class=\"kalkulator-form__choose-container\"\u003E\u003Cdiv class=\"kalkulator-form__choose-radio\" ng-class=\"{'active': $ctrl.activeTab=='0'}\"\u003E\u003Cinput id=\"kalkulator-form__radio1\" type=\"radio\" name=\"kalkulator-tab\" ng-model=\"$ctrl.activeTab\" value=\"0\"\u003E\u003Clabel class=\"radio\" for=\"kalkulator-form__radio1\"\u003EEgyénileg határozom meg\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-form__choose-radio\" ng-class=\"{'active': $ctrl.activeTab=='1'}\"\u003E\u003Cinput id=\"kalkulator-form__radio2\" type=\"radio\" name=\"kalkulator-tab\" ng-model=\"$ctrl.activeTab\" value=\"1\"\u003E\u003Clabel class=\"radio\" for=\"kalkulator-form__radio2\"\u003EKockázatvállalásom és a múltbeli hozamok alapján\u003Cbr\u003E határozom meg\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-form__choose-radio last-tab\" ng-class=\"{'active': $ctrl.activeTab=='2'}\"\u003E\u003Cinput id=\"kalkulator-form__radio3\" type=\"radio\" name=\"kalkulator-tab\" ng-model=\"$ctrl.activeTab\" value=\"2\"\u003E\u003Clabel class=\"radio\" for=\"kalkulator-form__radio3\"\u003EKockázatvállalásom és a hozamprognózis alapján\u003Cbr\u003E határozom meg\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-form__choose-panel\" ng-if=\"$ctrl.activeTab==0\"\u003E\u003Ch3\u003EHatározza meg az éves nettó hozamot!\u003C\u002Fh3\u003E\u003Cdiv class=\"row form__row slider-row\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"sr-only\" for=\"kalkulator-form__annual-net-yield\"\u003EÉves nettó hozam\u003C\u002Flabel\u003E\u003Cinput class=\"form-input form-input--input-xsmall\" id=\"kalkulator-form__annual-net-yield\" type=\"number\" ng-model=\"$ctrl.expectedYieldInput\" ng-model-options=\"{ updateOn: 'blur'}\"\u003E\u003Cspan\u003E%\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5 form-input__group\"\u003E\u003Cbutton class=\"button__slider-steps negative\" type=\"button\" ng-click=\"$ctrl.decreaseExpectedYield()\" ng-disabled=\"$ctrl.isExpectedYieldMinusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték csökkentése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Clabel class=\"sr-only\" for=\"kalkulator-form__deposit-range\"\u003EHavi befizetés csúszka:\u003C\u002Flabel\u003E\u003Crzslider id=\"kalkulator-form__deposit-range\" rz-slider-model=\"$ctrl.expectedYieldTab1\" rz-slider-options=\"$ctrl.expectedYieldOptions\"\u003E\u003C\u002Frzslider\u003E\u003Cbutton class=\"button__slider-steps positive\" type=\"button\" ng-click=\"$ctrl.increaseExpectedYield()\" ng-disabled=\"$ctrl.isExpectedYieldPlusDisabled()\"\u003E\u003Cspan class=\"sr-only\"\u003EÉrték növelése\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-form__choose-panel\" ng-if=\"$ctrl.activeTab==1\"\u003E\u003Ch3\u003EVálasszon egyet portfólióink közül!\u003C\u002Fh3\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__portfolio-select\" aria-describedby=\"tolltip__portfolio-select\"\u003EVálasztható portfólióink:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tolltip__portfolio-select\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content\"\u003E\u003Cp\u003EPortfóliók közül kockázatvállalási hajlandósága és élethelyzete figyelembe vételével választhat.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 form-input__group\"\u003E\u003Cselect class=\"select app-kapcsolat__select\" id=\"kalkulator-form__portfolio-select\" name=\"hozam\" ng-options=\"obj.averageYield as obj.portfolio for obj in $ctrl.hozamok\" ng-model=\"$ctrl.expectedYieldTab2\" required aria-describedby=\"kapcsolatSubjectError\"\u003E\u003Coption value=\"\" role=\"option\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"portfolioError\" form=\"$ctrl.kalkulatorForm\" input-name=\"hozam\" message-required=\"Válasszon portfóliót!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4 form-input__group\"\u003E\u003Ca class=\"button\" href=\"https:\u002F\u002Fwww.otpnyugdij.hu\u002Fhu\u002Fkerdoiv-kockazatvallalas-felmeresere\" target=\"_blank\"\u003EKitöltöm a kérdőívet\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\" ng-if=\"$ctrl.expectedYieldTab2\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__portfolio-average\" aria-describedby=\"tooltip__portfolio-average\"\u003EVárható hozamok:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tooltip__portfolio-average\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content tooltip-form-content\" ng-transclude=\"tooltipFormContent\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-7 form-input__group form-input__group--left\"\u003E\u003Cspan id=\"kalkulator-form__portfolio-average\"\u003E\u003Cstrong\u003E{{$ctrl.expectedYieldTab2 | number}}%\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-form__choose-panel\" ng-if=\"$ctrl.activeTab==2\"\u003E\u003Ch3\u003EVálasszon egyet portfólióink közül!\u003C\u002Fh3\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__portfolio-select\" aria-describedby=\"tolltip__portfolio-select\"\u003EVálasztható portfólióink:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tolltip__portfolio-select\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content\"\u003E\u003Cp\u003EPortfóliók közül kockázatvállalási hajlandósága és élethelyzete figyelembe vételével választhat.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 form-input__group\"\u003E\u003Cselect class=\"select app-kapcsolat__select\" id=\"kalkulator-form__futureportfolio-select\" name=\"hozam-jovo\" ng-options=\"obj.expectedYield as obj.portfolio for obj in $ctrl.hozamok\" ng-model=\"$ctrl.expectedYieldTab3\" required aria-describedby=\"kapcsolatSubjectError\"\u003E\u003Coption value=\"\" role=\"option\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"portfolioError\" form=\"$ctrl.kalkulatorForm\" input-name=\"hozam-jovo\" message-required=\"Válasszon portfóliót!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4 form-input__group\"\u003E\u003Ca class=\"button\" href=\"https:\u002F\u002Fwww.otpnyugdij.hu\u002Fhu\u002Fkerdoiv-kockazatvallalas-felmeresere\" target=\"_blank\"\u003EKitöltöm a kérdőívet\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\" ng-if=\"$ctrl.expectedYieldTab3\"\u003E\u003Cdiv class=\"col-sm-5 form-input__group form-input__group--right\"\u003E\u003Clabel class=\"label\" for=\"kalkulator-form__portfolio-average\" aria-describedby=\"tooltip__portfolio-average\"\u003EVárható hozamok:\u003C\u002Flabel\u003E\u003Cdiv class=\"tooltip\" id=\"tooltip__portfolio-average\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content tooltip-form-content\" ng-transclude=\"tooltipFormContent\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-7 form-input__group form-input__group--left\"\u003E\u003Cspan id=\"kalkulator-form__portfolio-average\"\u003E\u003Cstrong\u003E{{$ctrl.expectedYieldTab3 | number}}%\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003Cdiv class=\"kalkulator-form__button-row\"\u003E\u003Cbutton class=\"button\" type=\"submit\" ng-click=\"$ctrl.calculate()\"\u003EKiszámolom\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"kalkulator-result\" id=\"kalkulator-result\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-10 col-sm-offset-1\"\u003E\u003Cdiv class=\"kalkulator-result__text text-center\"\u003E\u003Cp aria-describedby=\"tooltip__text\"\u003EÖnnek még legalább \u003Cstrong\u003E{{$ctrl.eredmeny.yearsLeftToRetire}} éve\u003C\u002Fstrong\u003E van az öregségi nyugdíjkorhatár betöltéséig.\u003Cspan class=\"tooltip\" id=\"tooltip__text\" role=\"tooltip\" tabindex=\"0\" tooltip=\"\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cspan class=\"tooltip-content\"\u003EJelenleg 65 év az öregségi nyugdíjkorhatár\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"table-container\"\u003E\u003Ctable class=\"kalkulator-result__table\" ng-if=\"$ctrl.isMegtakaritas()\"\u003E\u003Ccaption class=\"sr-only\"\u003EVárható összegek...\u003C\u002Fcaption\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EVárható megtakarítás tőkerésze\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.expectedCapitalOfSavings | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EVárható hozam\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.expectedYield | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EVárható vagyon\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.expectedAssets | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth scope=\"row\" style=\"padding-left: 65px;\"\u003Emelyből az \u003Cspan aria-describedby=\"tooltip__table-text\"\u003Eadó-visszatérítésből származó \u003Cbr\u003Evagyonrész\u003C\u002Fspan\u003E\u003Cdiv class=\"tooltip\" id=\"tooltip__table-text\" role=\"tooltip\" tabindex=\"0\"\u003E\u003Cimg class=\"tooltip-icon\" src=\"\u002Fstatic\u002Fassets\u002Fimg\u002Finfo.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip-content tooltip-result-content\" ng-transclude=\"tooltipResultContent\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003Eösszege\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.taxRefund | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EVárható havi nyugdíjjáradék összege (10 évre)\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.expectedMonthlyRetirementAnnuity10Years | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EVárható havi nyugdíjjáradék összege (20 évre)\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.expectedMonthlyRetirementAnnuity20Years | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003Ctable class=\"kalkulator-result__table\" ng-if=\"$ctrl.isJaradek()\"\u003E\u003Ccaption class=\"sr-only\"\u003EVárható összegek...\u003C\u002Fcaption\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EHavi befizetés összege adó-visszatérítés igénybevétele esetén\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.monthlyPaymentWithTaxRefund | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Cth scope=\"row\"\u003EHavi befizetés összege adó-visszatérítés igénybevétele nélkül\u003C\u002Fth\u003E\u003Ctd\u003E\u003Cstrong\u003E{{$ctrl.eredmeny.monthlyPaymentWithoutTaxRefund | currency:'':0}} Ft\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-result__buttons\"\u003E\u003Ca class=\"button\" href=\"https:\u002F\u002Fmagan.onyp.otpportalok.hu\u002Fbelepesi-nyilatkozat-regisztracio?kod=A2418\" target=\"_blank\"\u003EBelépek az OTP Nyugdíjpénztárba\u003C\u002Fa\u003E\u003Ca class=\"button\" ng-href=\"{{$ctrl.getPdfUrl()}}\" target=\"_blank\"\u003EKalkuláció letöltése\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"kalkulator-result__text\"\u003E\u003Cp\u003EA kalkulátort az OTP Nyugdíjpénztár készítette a pénztártagok és érdeklődők tájékoztatása érdekében.\u003C\u002Fp\u003E\u003Cp\u003EA kalkulátor a befizetések után jelenleg igénybe vehető 20%-os adó-visszatérítéssel és azok várható hozamával jövedelemtől függetlenül mindvégig számol. Az adó-visszatérítés felső határa maximum évi 150 000 Ft.\u003C\u002Fp\u003E\u003Cp\u003EA számításnál az OTP Nyugdíjpénztár hatályos Alapszabályában rögzített sávos költséglevonását vettük figyelembe.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EFelhívjuk figyelmét, hogy a számítás eredménye kizárólag tájékoztató jellegű, a kiszámolt összegek becslések; azok nem minősülnek ajánlattételnek és elérése a jövőben nem garantálható.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"kalkulator-vhk\"\u003E\u003Ch3 class=\"kalkulator-vhk__title\"\u003EKérdése van? Várjuk megkeresését!\u003C\u002Fh3\u003E\u003Cform class=\"app-visszahivas-keres__form\" name=\"$ctrl.visszahivasKeresForm\" novalidate ng-submit=\"$ctrl.postContactForm()\" ng-show=\"!$ctrl.success\"\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_kalkulator_nev\"\u003ENév\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input onfocus\" id=\"{{$ctrl.id}}_kalkulator_nev\" type=\"text\" name=\"nev\" ng-model=\"$ctrl.model.name\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.simpleText\" required aria-describedby=\"{{$ctrl.id}}_vhkNameErrorSavingsCalculator\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkNameErrorSavingsCalculator\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"nev\" message-required=\"Kérjük adja meg a nevét!\" message-pattern=\"Kérjük helyesen adja meg a nevét!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_kalkulator_telefon\"\u003ETelefonszám\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"{{$ctrl.id}}_kalkulator_telefon\" type=\"tel\" name=\"telefon\" ng-model=\"$ctrl.model.phone\" maxlength=\"25\" ng-pattern=\"$ctrl.patterns.phone\" required aria-describedby=\"{{$ctrl.id}}_vhkPhoneErrorSavingsCalculator\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkPhoneErrorSavingsCalculator\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"telefon\" message-pattern=\"Kérjük helyesen adja meg a telefonszámot!\" message-required=\"Kérjük adja meg a telefonszámát!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_kalkulator_email\"\u003EE-mail cím:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"{{$ctrl.id}}_kalkulator_email\" type=\"email\" name=\"email\" ng-model=\"$ctrl.model.email\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.email\" ng-model-options=\"{updateOn: 'blur'}\" aria-describedby=\"{{$ctrl.id}}_vhkEmailErrorSavingsCalculator\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkEmailErrorSavingsCalculator\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"email\" message-pattern=\"Hibásan adta meg az e-mail címet, kérjük pontosítsa az adatokat!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_kalkulator_idopont\"\u003EVisszahívás időpontja\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cselect class=\"select\" id=\"{{$ctrl.id}}_kalkulator_idopont\" name=\"idopont\" ng-model=\"$ctrl.model.time\" required inputerrorId=\"{{$ctrl.id}}_vhkCallbackErrorSavingsCalculator\"\u003E\u003Coption value=\"\" disabled selected role=\"option\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003Coption value=\"{{ idopont }}\" ng-repeat=\"idopont in $ctrl.visszahivasIdok track by $index\" role=\"option\"\u003E{{ idopont }}\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkCallbackErrorSavingsCalculator\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"idopont\" message-required=\"Kérjük válasszon időpontot!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row captcha__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"kalkulator_captcha\"\u003EEllenőrzés\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"captcha\"\u003E\u003Cdiv vc-recaptcha key=\"'6LdfJB8TAAAAAPGueZFYId4-pMm-6RvQ2Tz6ZmyO'\" ng-model=\"$ctrl.model.captchaValue\" name=\"captcha\" required on-expire=\"this.resetCaptcha()\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkCaptchaErrorSavingsCalculator\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"captcha\" message-required=\"Hibásan adta meg a képen szereplő szöveget, kérjük pontosítsa az adatokat!\" message-pattern=\"Kérjük helyesen adja meg a képen szereplő szöveget!\" message-server-error=\"Hibásan adta meg a képen szereplő szöveget, kérjük pontosítsa az adatokat!\"\u003E\u003C\u002Finput-error\u003E\u003Cdiv class=\"checkbox__item\"\u003E\u003Cinput id=\"visszahivas-keres-form__adatvedelmi\" type=\"checkbox\" name=\"adatvedelmi\" ng-model=\"$ctrl.adatvedelmiIsChecked\"\u003E\u003Clabel class=\"checkbox\" for=\"visszahivas-keres-form__adatvedelmi\"\u003EKijelentem, hogy az  \u003Ca href=\"https:\u002F\u002Fwww.otpnyugdij.hu\u002Fstatic\u002Fotpnyugdij\u002Fdownload\u002Fonyp_adatkezelesi_tajekoztato.pdf\" target=\"_blank\" rel=\"noopener noreferrer\"\u003EAdatkezelési tájékoztató\u003C\u002Fa\u003E tartalmát megismertem és tudomásul vettem a tájékoztató III. fejezet 5. pontjában leírt adatkezelést.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button\" type=\"submit\" ng-disabled=\"$ctrl.visszahivasKeresForm.$invalid || !$ctrl.adatvedelmiIsChecked\" ng-click=\"$ctrl.postVisszahivasKeresForm()\"\u003EVisszahívást kérek\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"app-visszahivas-keres__success\" ng-show=\"$ctrl.success\"\u003E\u003Cp class=\"app-visszahivas-keres__success-text\" tabindex=\"-1\"\u003EKöszönjük érdeklődését!\u003Cbr\u003EMunkatársunk hamarosan felveszi Önnel a kapcsolatot.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-kalkulator\"\u003E\u003Cdiv ng-if=\"$ctrl.technicalError\"\u003ETechnikai hiba történt\u003C\u002Fdiv\u003E\u003Ch2 class=\"app-kalkulator__title\" ng-if=\"$ctrl.tipus=='megtakaritas'\"\u003ESzámolja ki, milyen megtakarításra számíthat havi befizetései alapján!\u003C\u002Fh2\u003E\u003Ch2 class=\"app-kalkulator__title\" ng-if=\"$ctrl.tipus=='jaradek'\"\u003ESzámolja ki, hogy a vágyott havi nyugdíj-kiegészítéshez, milyen összegű rendszeres megtakarítás szükséges!\u003C\u002Fh2\u003E\u003Ckalkulator-form hozamok=\"$ctrl.hozamok\" tipus=\"$ctrl.tipus\" vegpontok=\"$ctrl.vegpontok\" on-tab-change=\"$ctrl.resetResults()\" on-calculate=\"$ctrl.calculate(data)\"\u003E\u003Ctooltip-form-content ng-transclude=\"tooltipFormContent\"\u003E\u003C\u002Ftooltip-form-content\u003E\u003C\u002Fkalkulator-form\u003E\u003Ckalkulator-result ng-if=\"$ctrl.eredmeny\" tipus=\"$ctrl.tipus\" eredmeny=\"$ctrl.eredmeny\"\u003E\u003Ctooltip-result-content ng-transclude=\"tooltipResultContent\"\u003E\u003C\u002Ftooltip-result-content\u003E\u003C\u002Fkalkulator-result\u003E\u003Ckalkulator-vhk id=\"calculator\" ng-if=\"$ctrl.eredmeny\" visszahivas-idok=\"$ctrl.visszahivasIdok\" success=\"$ctrl.vhkSuccess\" on-post-form=\"$ctrl.sendVhk(data)\"\u003E\u003C\u002Fkalkulator-vhk\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })

},[541]);


// WEBPACK FOOTER //
// application/kalkulator.bundle.js